var ni = Object.defineProperty;
var oi = (y, i, n) => i in y ? ni(y, i, { enumerable: !0, configurable: !0, writable: !0, value: n }) : y[i] = n;
var Z = (y, i, n) => oi(y, typeof i != "symbol" ? i + "" : i, n);
/*! Pacifa3d Sdk v1.2.0 | 2025-09-30T16:54:28.093Z */
class si {
  constructor(i) {
    Z(this, "apiUrl");
    Z(this, "cachedResponses", {});
    this.apiUrl = i;
  }
  async getTopView(i, n, o = {}) {
    const a = {
      stadium: i,
      match: "",
      blockIDs: (o.blockIds || []).join(","),
      separator: ",",
      include: "" + ((o == null ? void 0 : o.included) ?? !1),
      variable: n,
      domain: "",
      idStyleAssoc: JSON.stringify(this.styleConfigsToApi(o.blocksStyles)),
      standIDs: (o.standIds || []).join(","),
      idStyleAssocStands: JSON.stringify(this.styleConfigsToApi(o.standsStyles)),
      noRoof: "true",
      zoom: "false"
    };
    return await this.apiCall("GetTopView", a);
  }
  async getStand(i, n, o, a = {}) {
    const h = {
      stadium: i,
      standName: n,
      blocks: (a.blockIds || []).join(","),
      separator: ",",
      include: "" + ((a == null ? void 0 : a.included) ?? !1),
      variable: o,
      domain: "",
      idStyleAssoc: JSON.stringify(this.styleConfigsToApi(a.blocksStyles)),
      zoom: "false"
    };
    return await this.apiCall("GetStand", h);
  }
  async getBlock(i, n, o, a = {}) {
    const h = {
      stadium: i,
      blockId: n,
      seats: (a.seatIds || []).join(","),
      separator: ",",
      include: "" + (a.included ?? !1),
      variable: o,
      domain: "",
      idStyleAssoc: JSON.stringify(this.styleConfigsToApi(a.seatsStyles)),
      standIDs: "[]",
      zoom: "false"
    };
    return await this.apiCall("GetBlock", h);
  }
  async getStandPanoUrl(i, n) {
    const o = {
      stadium: i,
      stand: n,
      configuration: ""
    };
    return await this.cachedApiCall("GetStandPanoUrl", o);
  }
  async getBlockPanoUrl(i, n) {
    const o = {
      stadium: i,
      block: n,
      configuration: ""
    };
    return await this.cachedApiCall("GetBlockPanoUrl", o);
  }
  async getSeatPanoUrl(i, n, o) {
    const a = {
      stadium: i,
      block: n,
      seat: o,
      configuration: "",
      type: "default"
    };
    return await this.cachedApiCall("GetPanoUrl", a);
  }
  async getStandPanoPreview(i, n) {
    return (await this.getStandPanoUrl(i, n)).replace(/Pano\.html\?p=/, "panos/") + ".tiles/thumb.jpg";
  }
  async getBlockPanoPreview(i, n) {
    return (await this.getBlockPanoUrl(i, n)).replace(/Pano\.html\?p=/, "panos/") + ".tiles/thumb.jpg";
  }
  async getSeatPanoPreview(i, n, o) {
    return (await this.getSeatPanoUrl(i, n, o)).replace(/Pano\.html\?p=/, "panos/") + ".tiles/thumb.jpg";
  }
  async getBlockIds(i, n) {
    const o = {
      stadium: i,
      stand: n || "",
      configuration: "",
      match: ""
    };
    let a = await this.apiCall("GetStadiumData", o);
    return JSON.parse(a);
  }
  async getSeatIds(i, n) {
    const o = {
      stadium: i,
      block: n,
      configuration: "",
      match: ""
    };
    let a = await this.apiCall("GetBlockData", o);
    return JSON.parse(a);
  }
  async cachedApiCall(i, n) {
    const o = i + JSON.stringify(n);
    return this.cachedResponses[o] || (this.cachedResponses[o] = await this.apiCall(i, n)), this.cachedResponses[o];
  }
  async apiCall(i, n) {
    const o = await fetch(this.apiUrl + "/PanoProvider.asmx/" + i, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(n)
    });
    if (!o.ok)
      throw new Error(`HTTP error! status: ${o.status}`);
    const a = await o.json();
    if (a.d.error)
      throw console.error("Api error", a.d.errorMsg), new Error(a.d.errorMsg);
    return a.d.data;
  }
  async getContent(i) {
    const n = await fetch(this.apiUrl + "/" + i);
    if (n.ok)
      return await n.text();
    throw console.error("API getContent error ", i, await n.text()), new Error("Error " + n.status + " : " + n.statusText + " while loading " + i);
  }
  styleConfigsToApi(i) {
    return (i || []).map((n) => ({
      id: n.id,
      out: n.css,
      over: n.cssHover
    }));
  }
}
function Ee(y) {
  return y && y.__esModule && Object.prototype.hasOwnProperty.call(y, "default") ? y.default : y;
}
var _t = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
var fe;
function ri() {
  return fe || (fe = 1, function(y) {
    (function(i, n, o, a) {
      var h = ["", "webkit", "Moz", "MS", "ms", "o"], g = n.createElement("div"), E = "function", v = Math.round, d = Math.abs, s = Date.now;
      function c(t, e, r) {
        return setTimeout(Tt(t, r), e);
      }
      function f(t, e, r) {
        return Array.isArray(t) ? (w(t, r[e], r), !0) : !1;
      }
      function w(t, e, r) {
        var l;
        if (t)
          if (t.forEach)
            t.forEach(e, r);
          else if (t.length !== a)
            for (l = 0; l < t.length; )
              e.call(r, t[l], l, t), l++;
          else
            for (l in t)
              t.hasOwnProperty(l) && e.call(r, t[l], l, t);
      }
      function T(t, e, r) {
        var l = "DEPRECATED METHOD: " + e + `
` + r + ` AT 
`;
        return function() {
          var u = new Error("get-stack-trace"), m = u && u.stack ? u.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", b = i.console && (i.console.warn || i.console.log);
          return b && b.call(i.console, l, m), t.apply(this, arguments);
        };
      }
      var p;
      typeof Object.assign != "function" ? p = function(e) {
        if (e === a || e === null)
          throw new TypeError("Cannot convert undefined or null to object");
        for (var r = Object(e), l = 1; l < arguments.length; l++) {
          var u = arguments[l];
          if (u !== a && u !== null)
            for (var m in u)
              u.hasOwnProperty(m) && (r[m] = u[m]);
        }
        return r;
      } : p = Object.assign;
      var S = T(function(e, r, l) {
        for (var u = Object.keys(r), m = 0; m < u.length; )
          (!l || l && e[u[m]] === a) && (e[u[m]] = r[u[m]]), m++;
        return e;
      }, "extend", "Use `assign`."), P = T(function(e, r) {
        return S(e, r, !0);
      }, "merge", "Use `assign`.");
      function C(t, e, r) {
        var l = e.prototype, u;
        u = t.prototype = Object.create(l), u.constructor = t, u._super = l, r && p(u, r);
      }
      function Tt(t, e) {
        return function() {
          return t.apply(e, arguments);
        };
      }
      function wt(t, e) {
        return typeof t == E ? t.apply(e && e[0] || a, e) : t;
      }
      function qt(t, e) {
        return t === a ? e : t;
      }
      function ot(t, e, r) {
        w(rt(e), function(l) {
          t.addEventListener(l, r, !1);
        });
      }
      function st(t, e, r) {
        w(rt(e), function(l) {
          t.removeEventListener(l, r, !1);
        });
      }
      function Wt(t, e) {
        for (; t; ) {
          if (t == e)
            return !0;
          t = t.parentNode;
        }
        return !1;
      }
      function W(t, e) {
        return t.indexOf(e) > -1;
      }
      function rt(t) {
        return t.trim().split(/\s+/g);
      }
      function G(t, e, r) {
        if (t.indexOf && !r)
          return t.indexOf(e);
        for (var l = 0; l < t.length; ) {
          if (r && t[l][r] == e || !r && t[l] === e)
            return l;
          l++;
        }
        return -1;
      }
      function at(t) {
        return Array.prototype.slice.call(t, 0);
      }
      function Ht(t, e, r) {
        for (var l = [], u = [], m = 0; m < t.length; ) {
          var b = t[m][e];
          G(u, b) < 0 && l.push(t[m]), u[m] = b, m++;
        }
        return l = l.sort(function(M, N) {
          return M[e] > N[e];
        }), l;
      }
      function lt(t, e) {
        for (var r, l, u = e[0].toUpperCase() + e.slice(1), m = 0; m < h.length; ) {
          if (r = h[m], l = r ? r + u : e, l in t)
            return l;
          m++;
        }
        return a;
      }
      var be = 1;
      function Se() {
        return be++;
      }
      function Xt(t) {
        var e = t.ownerDocument || t;
        return e.defaultView || e.parentWindow || i;
      }
      var Ce = /mobile|tablet|ip(ad|hone|od)|android/i, Yt = "ontouchstart" in i, Pe = lt(i, "PointerEvent") !== a, Ie = Yt && Ce.test(navigator.userAgent), j = "touch", xe = "pen", bt = "mouse", Me = "kinect", Ae = 25, A = 1, H = 2, I = 4, O = 8, ct = 1, J = 2, K = 4, Q = 8, $ = 16, k = J | K, X = Q | $, Gt = k | X, Ft = ["x", "y"], ht = ["clientX", "clientY"];
      function _(t, e) {
        var r = this;
        this.manager = t, this.callback = e, this.element = t.element, this.target = t.options.inputTarget, this.domHandler = function(l) {
          wt(t.options.enable, [t]) && r.handler(l);
        }, this.init();
      }
      _.prototype = {
        /**
         * should handle the inputEvent data and trigger the callback
         * @virtual
         */
        handler: function() {
        },
        /**
         * bind the events
         */
        init: function() {
          this.evEl && ot(this.element, this.evEl, this.domHandler), this.evTarget && ot(this.target, this.evTarget, this.domHandler), this.evWin && ot(Xt(this.element), this.evWin, this.domHandler);
        },
        /**
         * unbind the events
         */
        destroy: function() {
          this.evEl && st(this.element, this.evEl, this.domHandler), this.evTarget && st(this.target, this.evTarget, this.domHandler), this.evWin && st(Xt(this.element), this.evWin, this.domHandler);
        }
      };
      function Ne(t) {
        var e, r = t.options.inputClass;
        return r ? e = r : Pe ? e = Ct : Ie ? e = pt : Yt ? e = Pt : e = ft, new e(t, Oe);
      }
      function Oe(t, e, r) {
        var l = r.pointers.length, u = r.changedPointers.length, m = e & A && l - u === 0, b = e & (I | O) && l - u === 0;
        r.isFirst = !!m, r.isFinal = !!b, m && (t.session = {}), r.eventType = e, Ze(t, r), t.emit("hammer.input", r), t.recognize(r), t.session.prevInput = r;
      }
      function Ze(t, e) {
        var r = t.session, l = e.pointers, u = l.length;
        r.firstInput || (r.firstInput = jt(e)), u > 1 && !r.firstMultiple ? r.firstMultiple = jt(e) : u === 1 && (r.firstMultiple = !1);
        var m = r.firstInput, b = r.firstMultiple, x = b ? b.center : m.center, M = e.center = Jt(l);
        e.timeStamp = s(), e.deltaTime = e.timeStamp - m.timeStamp, e.angle = St(x, M), e.distance = ut(x, M), _e(r, e), e.offsetDirection = Qt(e.deltaX, e.deltaY);
        var N = Kt(e.deltaTime, e.deltaX, e.deltaY);
        e.overallVelocityX = N.x, e.overallVelocityY = N.y, e.overallVelocity = d(N.x) > d(N.y) ? N.x : N.y, e.scale = b ? ke(b.pointers, l) : 1, e.rotation = b ? De(b.pointers, l) : 0, e.maxPointers = r.prevInput ? e.pointers.length > r.prevInput.maxPointers ? e.pointers.length : r.prevInput.maxPointers : e.pointers.length, ze(r, e);
        var U = t.element;
        Wt(e.srcEvent.target, U) && (U = e.srcEvent.target), e.target = U;
      }
      function _e(t, e) {
        var r = e.center, l = t.offsetDelta || {}, u = t.prevDelta || {}, m = t.prevInput || {};
        (e.eventType === A || m.eventType === I) && (u = t.prevDelta = {
          x: m.deltaX || 0,
          y: m.deltaY || 0
        }, l = t.offsetDelta = {
          x: r.x,
          y: r.y
        }), e.deltaX = u.x + (r.x - l.x), e.deltaY = u.y + (r.y - l.y);
      }
      function ze(t, e) {
        var r = t.lastInterval || e, l = e.timeStamp - r.timeStamp, u, m, b, x;
        if (e.eventType != O && (l > Ae || r.velocity === a)) {
          var M = e.deltaX - r.deltaX, N = e.deltaY - r.deltaY, U = Kt(l, M, N);
          m = U.x, b = U.y, u = d(U.x) > d(U.y) ? U.x : U.y, x = Qt(M, N), t.lastInterval = e;
        } else
          u = r.velocity, m = r.velocityX, b = r.velocityY, x = r.direction;
        e.velocity = u, e.velocityX = m, e.velocityY = b, e.direction = x;
      }
      function jt(t) {
        for (var e = [], r = 0; r < t.pointers.length; )
          e[r] = {
            clientX: v(t.pointers[r].clientX),
            clientY: v(t.pointers[r].clientY)
          }, r++;
        return {
          timeStamp: s(),
          pointers: e,
          center: Jt(e),
          deltaX: t.deltaX,
          deltaY: t.deltaY
        };
      }
      function Jt(t) {
        var e = t.length;
        if (e === 1)
          return {
            x: v(t[0].clientX),
            y: v(t[0].clientY)
          };
        for (var r = 0, l = 0, u = 0; u < e; )
          r += t[u].clientX, l += t[u].clientY, u++;
        return {
          x: v(r / e),
          y: v(l / e)
        };
      }
      function Kt(t, e, r) {
        return {
          x: e / t || 0,
          y: r / t || 0
        };
      }
      function Qt(t, e) {
        return t === e ? ct : d(t) >= d(e) ? t < 0 ? J : K : e < 0 ? Q : $;
      }
      function ut(t, e, r) {
        r || (r = Ft);
        var l = e[r[0]] - t[r[0]], u = e[r[1]] - t[r[1]];
        return Math.sqrt(l * l + u * u);
      }
      function St(t, e, r) {
        r || (r = Ft);
        var l = e[r[0]] - t[r[0]], u = e[r[1]] - t[r[1]];
        return Math.atan2(u, l) * 180 / Math.PI;
      }
      function De(t, e) {
        return St(e[1], e[0], ht) + St(t[1], t[0], ht);
      }
      function ke(t, e) {
        return ut(e[0], e[1], ht) / ut(t[0], t[1], ht);
      }
      var Be = {
        mousedown: A,
        mousemove: H,
        mouseup: I
      }, Ue = "mousedown", Re = "mousemove mouseup";
      function ft() {
        this.evEl = Ue, this.evWin = Re, this.pressed = !1, _.apply(this, arguments);
      }
      C(ft, _, {
        /**
         * handle mouse events
         * @param {Object} ev
         */
        handler: function(e) {
          var r = Be[e.type];
          r & A && e.button === 0 && (this.pressed = !0), r & H && e.which !== 1 && (r = I), this.pressed && (r & I && (this.pressed = !1), this.callback(this.manager, r, {
            pointers: [e],
            changedPointers: [e],
            pointerType: bt,
            srcEvent: e
          }));
        }
      });
      var Le = {
        pointerdown: A,
        pointermove: H,
        pointerup: I,
        pointercancel: O,
        pointerout: O
      }, Ve = {
        2: j,
        3: xe,
        4: bt,
        5: Me
        // see https://twitter.com/jacobrossi/status/480596438489890816
      }, $t = "pointerdown", te = "pointermove pointerup pointercancel";
      i.MSPointerEvent && !i.PointerEvent && ($t = "MSPointerDown", te = "MSPointerMove MSPointerUp MSPointerCancel");
      function Ct() {
        this.evEl = $t, this.evWin = te, _.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
      }
      C(Ct, _, {
        /**
         * handle mouse events
         * @param {Object} ev
         */
        handler: function(e) {
          var r = this.store, l = !1, u = e.type.toLowerCase().replace("ms", ""), m = Le[u], b = Ve[e.pointerType] || e.pointerType, x = b == j, M = G(r, e.pointerId, "pointerId");
          m & A && (e.button === 0 || x) ? M < 0 && (r.push(e), M = r.length - 1) : m & (I | O) && (l = !0), !(M < 0) && (r[M] = e, this.callback(this.manager, m, {
            pointers: r,
            changedPointers: [e],
            pointerType: b,
            srcEvent: e
          }), l && r.splice(M, 1));
        }
      });
      var qe = {
        touchstart: A,
        touchmove: H,
        touchend: I,
        touchcancel: O
      }, We = "touchstart", He = "touchstart touchmove touchend touchcancel";
      function ee() {
        this.evTarget = We, this.evWin = He, this.started = !1, _.apply(this, arguments);
      }
      C(ee, _, {
        handler: function(e) {
          var r = qe[e.type];
          if (r === A && (this.started = !0), !!this.started) {
            var l = Xe.call(this, e, r);
            r & (I | O) && l[0].length - l[1].length === 0 && (this.started = !1), this.callback(this.manager, r, {
              pointers: l[0],
              changedPointers: l[1],
              pointerType: j,
              srcEvent: e
            });
          }
        }
      });
      function Xe(t, e) {
        var r = at(t.touches), l = at(t.changedTouches);
        return e & (I | O) && (r = Ht(r.concat(l), "identifier")), [r, l];
      }
      var Ye = {
        touchstart: A,
        touchmove: H,
        touchend: I,
        touchcancel: O
      }, Ge = "touchstart touchmove touchend touchcancel";
      function pt() {
        this.evTarget = Ge, this.targetIds = {}, _.apply(this, arguments);
      }
      C(pt, _, {
        handler: function(e) {
          var r = Ye[e.type], l = Fe.call(this, e, r);
          l && this.callback(this.manager, r, {
            pointers: l[0],
            changedPointers: l[1],
            pointerType: j,
            srcEvent: e
          });
        }
      });
      function Fe(t, e) {
        var r = at(t.touches), l = this.targetIds;
        if (e & (A | H) && r.length === 1)
          return l[r[0].identifier] = !0, [r, r];
        var u, m, b = at(t.changedTouches), x = [], M = this.target;
        if (m = r.filter(function(N) {
          return Wt(N.target, M);
        }), e === A)
          for (u = 0; u < m.length; )
            l[m[u].identifier] = !0, u++;
        for (u = 0; u < b.length; )
          l[b[u].identifier] && x.push(b[u]), e & (I | O) && delete l[b[u].identifier], u++;
        if (x.length)
          return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            Ht(m.concat(x), "identifier"),
            x
          ];
      }
      var je = 2500, ie = 25;
      function Pt() {
        _.apply(this, arguments);
        var t = Tt(this.handler, this);
        this.touch = new pt(this.manager, t), this.mouse = new ft(this.manager, t), this.primaryTouch = null, this.lastTouches = [];
      }
      C(Pt, _, {
        /**
         * handle mouse and touch events
         * @param {Hammer} manager
         * @param {String} inputEvent
         * @param {Object} inputData
         */
        handler: function(e, r, l) {
          var u = l.pointerType == j, m = l.pointerType == bt;
          if (!(m && l.sourceCapabilities && l.sourceCapabilities.firesTouchEvents)) {
            if (u)
              Je.call(this, r, l);
            else if (m && Ke.call(this, l))
              return;
            this.callback(e, r, l);
          }
        },
        /**
         * remove the event listeners
         */
        destroy: function() {
          this.touch.destroy(), this.mouse.destroy();
        }
      });
      function Je(t, e) {
        t & A ? (this.primaryTouch = e.changedPointers[0].identifier, ne.call(this, e)) : t & (I | O) && ne.call(this, e);
      }
      function ne(t) {
        var e = t.changedPointers[0];
        if (e.identifier === this.primaryTouch) {
          var r = { x: e.clientX, y: e.clientY };
          this.lastTouches.push(r);
          var l = this.lastTouches, u = function() {
            var m = l.indexOf(r);
            m > -1 && l.splice(m, 1);
          };
          setTimeout(u, je);
        }
      }
      function Ke(t) {
        for (var e = t.srcEvent.clientX, r = t.srcEvent.clientY, l = 0; l < this.lastTouches.length; l++) {
          var u = this.lastTouches[l], m = Math.abs(e - u.x), b = Math.abs(r - u.y);
          if (m <= ie && b <= ie)
            return !0;
        }
        return !1;
      }
      var oe = lt(g.style, "touchAction"), se = oe !== a, re = "compute", ae = "auto", It = "manipulation", Y = "none", tt = "pan-x", et = "pan-y", dt = $e();
      function xt(t, e) {
        this.manager = t, this.set(e);
      }
      xt.prototype = {
        /**
         * set the touchAction value on the element or enable the polyfill
         * @param {String} value
         */
        set: function(t) {
          t == re && (t = this.compute()), se && this.manager.element.style && dt[t] && (this.manager.element.style[oe] = t), this.actions = t.toLowerCase().trim();
        },
        /**
         * just re-set the touchAction value
         */
        update: function() {
          this.set(this.manager.options.touchAction);
        },
        /**
         * compute the value for the touchAction property based on the recognizer's settings
         * @returns {String} value
         */
        compute: function() {
          var t = [];
          return w(this.manager.recognizers, function(e) {
            wt(e.options.enable, [e]) && (t = t.concat(e.getTouchAction()));
          }), Qe(t.join(" "));
        },
        /**
         * this method is called on each input cycle and provides the preventing of the browser behavior
         * @param {Object} input
         */
        preventDefaults: function(t) {
          var e = t.srcEvent, r = t.offsetDirection;
          if (this.manager.session.prevented) {
            e.preventDefault();
            return;
          }
          var l = this.actions, u = W(l, Y) && !dt[Y], m = W(l, et) && !dt[et], b = W(l, tt) && !dt[tt];
          if (u) {
            var x = t.pointers.length === 1, M = t.distance < 2, N = t.deltaTime < 250;
            if (x && M && N)
              return;
          }
          if (!(b && m) && (u || m && r & k || b && r & X))
            return this.preventSrc(e);
        },
        /**
         * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
         * @param {Object} srcEvent
         */
        preventSrc: function(t) {
          this.manager.session.prevented = !0, t.preventDefault();
        }
      };
      function Qe(t) {
        if (W(t, Y))
          return Y;
        var e = W(t, tt), r = W(t, et);
        return e && r ? Y : e || r ? e ? tt : et : W(t, It) ? It : ae;
      }
      function $e() {
        if (!se)
          return !1;
        var t = {}, e = i.CSS && i.CSS.supports;
        return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(r) {
          t[r] = e ? i.CSS.supports("touch-action", r) : !0;
        }), t;
      }
      var mt = 1, z = 2, F = 4, V = 8, R = V, it = 16, B = 32;
      function L(t) {
        this.options = p({}, this.defaults, t || {}), this.id = Se(), this.manager = null, this.options.enable = qt(this.options.enable, !0), this.state = mt, this.simultaneous = {}, this.requireFail = [];
      }
      L.prototype = {
        /**
         * @virtual
         * @type {Object}
         */
        defaults: {},
        /**
         * set options
         * @param {Object} options
         * @return {Recognizer}
         */
        set: function(t) {
          return p(this.options, t), this.manager && this.manager.touchAction.update(), this;
        },
        /**
         * recognize simultaneous with an other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        recognizeWith: function(t) {
          if (f(t, "recognizeWith", this))
            return this;
          var e = this.simultaneous;
          return t = vt(t, this), e[t.id] || (e[t.id] = t, t.recognizeWith(this)), this;
        },
        /**
         * drop the simultaneous link. it doesnt remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        dropRecognizeWith: function(t) {
          return f(t, "dropRecognizeWith", this) ? this : (t = vt(t, this), delete this.simultaneous[t.id], this);
        },
        /**
         * recognizer can only run when an other is failing
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        requireFailure: function(t) {
          if (f(t, "requireFailure", this))
            return this;
          var e = this.requireFail;
          return t = vt(t, this), G(e, t) === -1 && (e.push(t), t.requireFailure(this)), this;
        },
        /**
         * drop the requireFailure link. it does not remove the link on the other recognizer.
         * @param {Recognizer} otherRecognizer
         * @returns {Recognizer} this
         */
        dropRequireFailure: function(t) {
          if (f(t, "dropRequireFailure", this))
            return this;
          t = vt(t, this);
          var e = G(this.requireFail, t);
          return e > -1 && this.requireFail.splice(e, 1), this;
        },
        /**
         * has require failures boolean
         * @returns {boolean}
         */
        hasRequireFailures: function() {
          return this.requireFail.length > 0;
        },
        /**
         * if the recognizer can recognize simultaneous with an other recognizer
         * @param {Recognizer} otherRecognizer
         * @returns {Boolean}
         */
        canRecognizeWith: function(t) {
          return !!this.simultaneous[t.id];
        },
        /**
         * You should use `tryEmit` instead of `emit` directly to check
         * that all the needed recognizers has failed before emitting.
         * @param {Object} input
         */
        emit: function(t) {
          var e = this, r = this.state;
          function l(u) {
            e.manager.emit(u, t);
          }
          r < V && l(e.options.event + le(r)), l(e.options.event), t.additionalEvent && l(t.additionalEvent), r >= V && l(e.options.event + le(r));
        },
        /**
         * Check that all the require failure recognizers has failed,
         * if true, it emits a gesture event,
         * otherwise, setup the state to FAILED.
         * @param {Object} input
         */
        tryEmit: function(t) {
          if (this.canEmit())
            return this.emit(t);
          this.state = B;
        },
        /**
         * can we emit?
         * @returns {boolean}
         */
        canEmit: function() {
          for (var t = 0; t < this.requireFail.length; ) {
            if (!(this.requireFail[t].state & (B | mt)))
              return !1;
            t++;
          }
          return !0;
        },
        /**
         * update the recognizer
         * @param {Object} inputData
         */
        recognize: function(t) {
          var e = p({}, t);
          if (!wt(this.options.enable, [this, e])) {
            this.reset(), this.state = B;
            return;
          }
          this.state & (R | it | B) && (this.state = mt), this.state = this.process(e), this.state & (z | F | V | it) && this.tryEmit(e);
        },
        /**
         * return the state of the recognizer
         * the actual recognizing happens in this method
         * @virtual
         * @param {Object} inputData
         * @returns {Const} STATE
         */
        process: function(t) {
        },
        // jshint ignore:line
        /**
         * return the preferred touch-action
         * @virtual
         * @returns {Array}
         */
        getTouchAction: function() {
        },
        /**
         * called when the gesture isn't allowed to recognize
         * like when another is being recognized or it is disabled
         * @virtual
         */
        reset: function() {
        }
      };
      function le(t) {
        return t & it ? "cancel" : t & V ? "end" : t & F ? "move" : t & z ? "start" : "";
      }
      function ce(t) {
        return t == $ ? "down" : t == Q ? "up" : t == J ? "left" : t == K ? "right" : "";
      }
      function vt(t, e) {
        var r = e.manager;
        return r ? r.get(t) : t;
      }
      function D() {
        L.apply(this, arguments);
      }
      C(D, L, {
        /**
         * @namespace
         * @memberof AttrRecognizer
         */
        defaults: {
          /**
           * @type {Number}
           * @default 1
           */
          pointers: 1
        },
        /**
         * Used to check if it the recognizer receives valid input, like input.distance > 10.
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {Boolean} recognized
         */
        attrTest: function(t) {
          var e = this.options.pointers;
          return e === 0 || t.pointers.length === e;
        },
        /**
         * Process the input and return the state for the recognizer
         * @memberof AttrRecognizer
         * @param {Object} input
         * @returns {*} State
         */
        process: function(t) {
          var e = this.state, r = t.eventType, l = e & (z | F), u = this.attrTest(t);
          return l && (r & O || !u) ? e | it : l || u ? r & I ? e | V : e & z ? e | F : z : B;
        }
      });
      function gt() {
        D.apply(this, arguments), this.pX = null, this.pY = null;
      }
      C(gt, D, {
        /**
         * @namespace
         * @memberof PanRecognizer
         */
        defaults: {
          event: "pan",
          threshold: 10,
          pointers: 1,
          direction: Gt
        },
        getTouchAction: function() {
          var t = this.options.direction, e = [];
          return t & k && e.push(et), t & X && e.push(tt), e;
        },
        directionTest: function(t) {
          var e = this.options, r = !0, l = t.distance, u = t.direction, m = t.deltaX, b = t.deltaY;
          return u & e.direction || (e.direction & k ? (u = m === 0 ? ct : m < 0 ? J : K, r = m != this.pX, l = Math.abs(t.deltaX)) : (u = b === 0 ? ct : b < 0 ? Q : $, r = b != this.pY, l = Math.abs(t.deltaY))), t.direction = u, r && l > e.threshold && u & e.direction;
        },
        attrTest: function(t) {
          return D.prototype.attrTest.call(this, t) && (this.state & z || !(this.state & z) && this.directionTest(t));
        },
        emit: function(t) {
          this.pX = t.deltaX, this.pY = t.deltaY;
          var e = ce(t.direction);
          e && (t.additionalEvent = this.options.event + e), this._super.emit.call(this, t);
        }
      });
      function Mt() {
        D.apply(this, arguments);
      }
      C(Mt, D, {
        /**
         * @namespace
         * @memberof PinchRecognizer
         */
        defaults: {
          event: "pinch",
          threshold: 0,
          pointers: 2
        },
        getTouchAction: function() {
          return [Y];
        },
        attrTest: function(t) {
          return this._super.attrTest.call(this, t) && (Math.abs(t.scale - 1) > this.options.threshold || this.state & z);
        },
        emit: function(t) {
          if (t.scale !== 1) {
            var e = t.scale < 1 ? "in" : "out";
            t.additionalEvent = this.options.event + e;
          }
          this._super.emit.call(this, t);
        }
      });
      function At() {
        L.apply(this, arguments), this._timer = null, this._input = null;
      }
      C(At, L, {
        /**
         * @namespace
         * @memberof PressRecognizer
         */
        defaults: {
          event: "press",
          pointers: 1,
          time: 251,
          // minimal time of the pointer to be pressed
          threshold: 9
          // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
          return [ae];
        },
        process: function(t) {
          var e = this.options, r = t.pointers.length === e.pointers, l = t.distance < e.threshold, u = t.deltaTime > e.time;
          if (this._input = t, !l || !r || t.eventType & (I | O) && !u)
            this.reset();
          else if (t.eventType & A)
            this.reset(), this._timer = c(function() {
              this.state = R, this.tryEmit();
            }, e.time, this);
          else if (t.eventType & I)
            return R;
          return B;
        },
        reset: function() {
          clearTimeout(this._timer);
        },
        emit: function(t) {
          this.state === R && (t && t.eventType & I ? this.manager.emit(this.options.event + "up", t) : (this._input.timeStamp = s(), this.manager.emit(this.options.event, this._input)));
        }
      });
      function Nt() {
        D.apply(this, arguments);
      }
      C(Nt, D, {
        /**
         * @namespace
         * @memberof RotateRecognizer
         */
        defaults: {
          event: "rotate",
          threshold: 0,
          pointers: 2
        },
        getTouchAction: function() {
          return [Y];
        },
        attrTest: function(t) {
          return this._super.attrTest.call(this, t) && (Math.abs(t.rotation) > this.options.threshold || this.state & z);
        }
      });
      function Ot() {
        D.apply(this, arguments);
      }
      C(Ot, D, {
        /**
         * @namespace
         * @memberof SwipeRecognizer
         */
        defaults: {
          event: "swipe",
          threshold: 10,
          velocity: 0.3,
          direction: k | X,
          pointers: 1
        },
        getTouchAction: function() {
          return gt.prototype.getTouchAction.call(this);
        },
        attrTest: function(t) {
          var e = this.options.direction, r;
          return e & (k | X) ? r = t.overallVelocity : e & k ? r = t.overallVelocityX : e & X && (r = t.overallVelocityY), this._super.attrTest.call(this, t) && e & t.offsetDirection && t.distance > this.options.threshold && t.maxPointers == this.options.pointers && d(r) > this.options.velocity && t.eventType & I;
        },
        emit: function(t) {
          var e = ce(t.offsetDirection);
          e && this.manager.emit(this.options.event + e, t), this.manager.emit(this.options.event, t);
        }
      });
      function yt() {
        L.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
      }
      C(yt, L, {
        /**
         * @namespace
         * @memberof PinchRecognizer
         */
        defaults: {
          event: "tap",
          pointers: 1,
          taps: 1,
          interval: 300,
          // max time between the multi-tap taps
          time: 250,
          // max time of the pointer to be down (like finger on the screen)
          threshold: 9,
          // a minimal movement is ok, but keep it low
          posThreshold: 10
          // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
          return [It];
        },
        process: function(t) {
          var e = this.options, r = t.pointers.length === e.pointers, l = t.distance < e.threshold, u = t.deltaTime < e.time;
          if (this.reset(), t.eventType & A && this.count === 0)
            return this.failTimeout();
          if (l && u && r) {
            if (t.eventType != I)
              return this.failTimeout();
            var m = this.pTime ? t.timeStamp - this.pTime < e.interval : !0, b = !this.pCenter || ut(this.pCenter, t.center) < e.posThreshold;
            this.pTime = t.timeStamp, this.pCenter = t.center, !b || !m ? this.count = 1 : this.count += 1, this._input = t;
            var x = this.count % e.taps;
            if (x === 0)
              return this.hasRequireFailures() ? (this._timer = c(function() {
                this.state = R, this.tryEmit();
              }, e.interval, this), z) : R;
          }
          return B;
        },
        failTimeout: function() {
          return this._timer = c(function() {
            this.state = B;
          }, this.options.interval, this), B;
        },
        reset: function() {
          clearTimeout(this._timer);
        },
        emit: function() {
          this.state == R && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
        }
      });
      function q(t, e) {
        return e = e || {}, e.recognizers = qt(e.recognizers, q.defaults.preset), new Zt(t, e);
      }
      q.VERSION = "2.0.7", q.defaults = {
        /**
         * set if DOM events are being triggered.
         * But this is slower and unused by simple implementations, so disabled by default.
         * @type {Boolean}
         * @default false
         */
        domEvents: !1,
        /**
         * The value for the touchAction property/fallback.
         * When set to `compute` it will magically set the correct value based on the added recognizers.
         * @type {String}
         * @default compute
         */
        touchAction: re,
        /**
         * @type {Boolean}
         * @default true
         */
        enable: !0,
        /**
         * EXPERIMENTAL FEATURE -- can be removed/changed
         * Change the parent input target element.
         * If Null, then it is being set the to main element.
         * @type {Null|EventTarget}
         * @default null
         */
        inputTarget: null,
        /**
         * force an input class
         * @type {Null|Function}
         * @default null
         */
        inputClass: null,
        /**
         * Default recognizer setup when calling `Hammer()`
         * When creating a new Manager these will be skipped.
         * @type {Array}
         */
        preset: [
          // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
          [Nt, { enable: !1 }],
          [Mt, { enable: !1 }, ["rotate"]],
          [Ot, { direction: k }],
          [gt, { direction: k }, ["swipe"]],
          [yt],
          [yt, { event: "doubletap", taps: 2 }, ["tap"]],
          [At]
        ],
        /**
         * Some CSS properties can be used to improve the working of Hammer.
         * Add them to this method and they will be set when creating a new Manager.
         * @namespace
         */
        cssProps: {
          /**
           * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
           * @type {String}
           * @default 'none'
           */
          userSelect: "none",
          /**
           * Disable the Windows Phone grippers when pressing an element.
           * @type {String}
           * @default 'none'
           */
          touchSelect: "none",
          /**
           * Disables the default callout shown when you touch and hold a touch target.
           * On iOS, when you touch and hold a touch target such as a link, Safari displays
           * a callout containing information about the link. This property allows you to disable that callout.
           * @type {String}
           * @default 'none'
           */
          touchCallout: "none",
          /**
           * Specifies whether zooming is enabled. Used by IE10>
           * @type {String}
           * @default 'none'
           */
          contentZooming: "none",
          /**
           * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
           * @type {String}
           * @default 'none'
           */
          userDrag: "none",
          /**
           * Overrides the highlight color shown when the user taps a link or a JavaScript
           * clickable element in iOS. This property obeys the alpha value, if specified.
           * @type {String}
           * @default 'rgba(0,0,0,0)'
           */
          tapHighlightColor: "rgba(0,0,0,0)"
        }
      };
      var ti = 1, he = 2;
      function Zt(t, e) {
        this.options = p({}, q.defaults, e || {}), this.options.inputTarget = this.options.inputTarget || t, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = t, this.input = Ne(this), this.touchAction = new xt(this, this.options.touchAction), ue(this, !0), w(this.options.recognizers, function(r) {
          var l = this.add(new r[0](r[1]));
          r[2] && l.recognizeWith(r[2]), r[3] && l.requireFailure(r[3]);
        }, this);
      }
      Zt.prototype = {
        /**
         * set options
         * @param {Object} options
         * @returns {Manager}
         */
        set: function(t) {
          return p(this.options, t), t.touchAction && this.touchAction.update(), t.inputTarget && (this.input.destroy(), this.input.target = t.inputTarget, this.input.init()), this;
        },
        /**
         * stop recognizing for this session.
         * This session will be discarded, when a new [input]start event is fired.
         * When forced, the recognizer cycle is stopped immediately.
         * @param {Boolean} [force]
         */
        stop: function(t) {
          this.session.stopped = t ? he : ti;
        },
        /**
         * run the recognizers!
         * called by the inputHandler function on every movement of the pointers (touches)
         * it walks through all the recognizers and tries to detect the gesture that is being made
         * @param {Object} inputData
         */
        recognize: function(t) {
          var e = this.session;
          if (!e.stopped) {
            this.touchAction.preventDefaults(t);
            var r, l = this.recognizers, u = e.curRecognizer;
            (!u || u && u.state & R) && (u = e.curRecognizer = null);
            for (var m = 0; m < l.length; )
              r = l[m], e.stopped !== he && // 1
              (!u || r == u || // 2
              r.canRecognizeWith(u)) ? r.recognize(t) : r.reset(), !u && r.state & (z | F | V) && (u = e.curRecognizer = r), m++;
          }
        },
        /**
         * get a recognizer by its event name.
         * @param {Recognizer|String} recognizer
         * @returns {Recognizer|Null}
         */
        get: function(t) {
          if (t instanceof L)
            return t;
          for (var e = this.recognizers, r = 0; r < e.length; r++)
            if (e[r].options.event == t)
              return e[r];
          return null;
        },
        /**
         * add a recognizer to the manager
         * existing recognizers with the same event name will be removed
         * @param {Recognizer} recognizer
         * @returns {Recognizer|Manager}
         */
        add: function(t) {
          if (f(t, "add", this))
            return this;
          var e = this.get(t.options.event);
          return e && this.remove(e), this.recognizers.push(t), t.manager = this, this.touchAction.update(), t;
        },
        /**
         * remove a recognizer by name or instance
         * @param {Recognizer|String} recognizer
         * @returns {Manager}
         */
        remove: function(t) {
          if (f(t, "remove", this))
            return this;
          if (t = this.get(t), t) {
            var e = this.recognizers, r = G(e, t);
            r !== -1 && (e.splice(r, 1), this.touchAction.update());
          }
          return this;
        },
        /**
         * bind event
         * @param {String} events
         * @param {Function} handler
         * @returns {EventEmitter} this
         */
        on: function(t, e) {
          if (t !== a && e !== a) {
            var r = this.handlers;
            return w(rt(t), function(l) {
              r[l] = r[l] || [], r[l].push(e);
            }), this;
          }
        },
        /**
         * unbind event, leave emit blank to remove all handlers
         * @param {String} events
         * @param {Function} [handler]
         * @returns {EventEmitter} this
         */
        off: function(t, e) {
          if (t !== a) {
            var r = this.handlers;
            return w(rt(t), function(l) {
              e ? r[l] && r[l].splice(G(r[l], e), 1) : delete r[l];
            }), this;
          }
        },
        /**
         * emit event to the listeners
         * @param {String} event
         * @param {Object} data
         */
        emit: function(t, e) {
          this.options.domEvents && ei(t, e);
          var r = this.handlers[t] && this.handlers[t].slice();
          if (!(!r || !r.length)) {
            e.type = t, e.preventDefault = function() {
              e.srcEvent.preventDefault();
            };
            for (var l = 0; l < r.length; )
              r[l](e), l++;
          }
        },
        /**
         * destroy the manager and unbinds all events
         * it doesn't unbind dom events, that is the user own responsibility
         */
        destroy: function() {
          this.element && ue(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
        }
      };
      function ue(t, e) {
        var r = t.element;
        if (r.style) {
          var l;
          w(t.options.cssProps, function(u, m) {
            l = lt(r.style, m), e ? (t.oldCssProps[l] = r.style[l], r.style[l] = u) : r.style[l] = t.oldCssProps[l] || "";
          }), e || (t.oldCssProps = {});
        }
      }
      function ei(t, e) {
        var r = n.createEvent("Event");
        r.initEvent(t, !0, !0), r.gesture = e, e.target.dispatchEvent(r);
      }
      p(q, {
        INPUT_START: A,
        INPUT_MOVE: H,
        INPUT_END: I,
        INPUT_CANCEL: O,
        STATE_POSSIBLE: mt,
        STATE_BEGAN: z,
        STATE_CHANGED: F,
        STATE_ENDED: V,
        STATE_RECOGNIZED: R,
        STATE_CANCELLED: it,
        STATE_FAILED: B,
        DIRECTION_NONE: ct,
        DIRECTION_LEFT: J,
        DIRECTION_RIGHT: K,
        DIRECTION_UP: Q,
        DIRECTION_DOWN: $,
        DIRECTION_HORIZONTAL: k,
        DIRECTION_VERTICAL: X,
        DIRECTION_ALL: Gt,
        Manager: Zt,
        Input: _,
        TouchAction: xt,
        TouchInput: pt,
        MouseInput: ft,
        PointerEventInput: Ct,
        TouchMouseInput: Pt,
        SingleTouchInput: ee,
        Recognizer: L,
        AttrRecognizer: D,
        Tap: yt,
        Pan: gt,
        Swipe: Ot,
        Pinch: Mt,
        Rotate: Nt,
        Press: At,
        on: ot,
        off: st,
        each: w,
        merge: P,
        extend: S,
        assign: p,
        inherit: C,
        bindFn: Tt,
        prefixed: lt
      });
      var ii = typeof i < "u" ? i : typeof self < "u" ? self : {};
      ii.Hammer = q, y.exports ? y.exports = q : i[o] = q;
    })(window, document, "Hammer");
  }(_t)), _t.exports;
}
var ai = ri();
const Et = /* @__PURE__ */ Ee(ai);
var zt, pe;
function li() {
  return pe || (pe = 1, zt = function() {
    var y = "", i, n, o, a = [], h = { passive: !0 }, g = { passive: !1 };
    window.addEventListener ? (i = "addEventListener", n = "removeEventListener") : (i = "attachEvent", n = "detachEvent", y = "on"), o = "onwheel" in document.createElement("div") ? "wheel" : (
      // Modern browsers support "wheel"
      document.onmousewheel !== void 0 ? "mousewheel" : (
        // Webkit and IE support at least "mousewheel"
        "DOMMouseScroll"
      )
    );
    function E(T, p) {
      var S = function(P) {
        !P && (P = window.event);
        var C = {
          // keep a ref to the original event object
          originalEvent: P,
          target: P.target || P.srcElement,
          type: "wheel",
          deltaMode: P.type == "MozMousePixelScroll" ? 0 : 1,
          deltaX: 0,
          delatZ: 0,
          preventDefault: function() {
            P.preventDefault ? P.preventDefault() : P.returnValue = !1;
          }
        };
        return o == "mousewheel" ? (C.deltaY = -0.025 * P.wheelDelta, P.wheelDeltaX && (C.deltaX = -0.025 * P.wheelDeltaX)) : C.deltaY = P.detail, p(C);
      };
      return a.push({
        element: T,
        fn: S
      }), S;
    }
    function v(T) {
      for (var p = 0; p < a.length; p++)
        if (a[p].element === T)
          return a[p].fn;
      return function() {
      };
    }
    function d(T) {
      for (var p = 0; p < a.length; p++)
        if (a[p].element === T)
          return a.splice(p, 1);
    }
    function s(T, p, S, P) {
      var C;
      o === "wheel" ? C = S : C = E(T, S), T[i](
        y + p,
        C,
        P ? h : g
      );
    }
    function c(T, p, S, P) {
      var C;
      o === "wheel" ? C = S : C = v(T), T[n](
        y + p,
        C,
        P ? h : g
      ), d(T);
    }
    function f(T, p, S) {
      s(T, o, p, S), o == "DOMMouseScroll" && s(T, "MozMousePixelScroll", p, S);
    }
    function w(T, p, S) {
      c(T, o, p, S), o == "DOMMouseScroll" && c(T, "MozMousePixelScroll", p, S);
    }
    return {
      on: f,
      off: w
    };
  }()), zt;
}
var Dt, de;
function Lt() {
  if (de) return Dt;
  de = 1, Dt = {
    /**
     * Extends an object
     *
     * @param  {Object} target object to extend
     * @param  {Object} source object to take properties from
     * @return {Object}        extended object
     */
    extend: function(i, n) {
      i = i || {};
      for (var o in n)
        this.isObject(n[o]) ? i[o] = this.extend(i[o], n[o]) : i[o] = n[o];
      return i;
    },
    /**
     * Checks if an object is a DOM element
     *
     * @param  {Object}  o HTML element or String
     * @return {Boolean}   returns true if object is a DOM element
     */
    isElement: function(i) {
      return i instanceof HTMLElement || i instanceof SVGElement || i instanceof SVGSVGElement || //DOM2
      i && typeof i == "object" && i !== null && i.nodeType === 1 && typeof i.nodeName == "string";
    },
    /**
     * Checks if an object is an Object
     *
     * @param  {Object}  o Object
     * @return {Boolean}   returns true if object is an Object
     */
    isObject: function(i) {
      return Object.prototype.toString.call(i) === "[object Object]";
    },
    /**
     * Checks if variable is Number
     *
     * @param  {Integer|Float}  n
     * @return {Boolean}   returns true if variable is Number
     */
    isNumber: function(i) {
      return !isNaN(parseFloat(i)) && isFinite(i);
    },
    /**
     * Search for an SVG element
     *
     * @param  {Object|String} elementOrSelector DOM Element or selector String
     * @return {Object|Null}                   SVG or null
     */
    getSvg: function(i) {
      var n, o;
      if (this.isElement(i))
        n = i;
      else if (typeof i == "string" || i instanceof String) {
        if (n = document.querySelector(i), !n)
          throw new Error(
            "Provided selector did not find any elements. Selector: " + i
          );
      } else
        throw new Error("Provided selector is not an HTML object nor String");
      if (n.tagName.toLowerCase() === "svg")
        o = n;
      else if (n.tagName.toLowerCase() === "object")
        o = n.contentDocument.documentElement;
      else if (n.tagName.toLowerCase() === "embed")
        o = n.getSVGDocument().documentElement;
      else
        throw n.tagName.toLowerCase() === "img" ? new Error(
          'Cannot script an SVG in an "img" element. Please use an "object" element or an in-line SVG.'
        ) : new Error("Cannot get SVG.");
      return o;
    },
    /**
     * Attach a given context to a function
     * @param  {Function} fn      Function
     * @param  {Object}   context Context
     * @return {Function}           Function with certain context
     */
    proxy: function(i, n) {
      return function() {
        return i.apply(n, arguments);
      };
    },
    /**
     * Returns object type
     * Uses toString that returns [object SVGPoint]
     * And than parses object type from string
     *
     * @param  {Object} o Any object
     * @return {String}   Object type
     */
    getType: function(i) {
      return Object.prototype.toString.apply(i).replace(/^\[object\s/, "").replace(/\]$/, "");
    },
    /**
     * If it is a touch event than add clientX and clientY to event object
     *
     * @param  {Event} evt
     * @param  {SVGSVGElement} svg
     */
    mouseAndTouchNormalize: function(i, n) {
      if (i.clientX === void 0 || i.clientX === null)
        if (i.clientX = 0, i.clientY = 0, i.touches !== void 0 && i.touches.length) {
          if (i.touches[0].clientX !== void 0)
            i.clientX = i.touches[0].clientX, i.clientY = i.touches[0].clientY;
          else if (i.touches[0].pageX !== void 0) {
            var o = n.getBoundingClientRect();
            i.clientX = i.touches[0].pageX - o.left, i.clientY = i.touches[0].pageY - o.top;
          }
        } else i.originalEvent !== void 0 && i.originalEvent.clientX !== void 0 && (i.clientX = i.originalEvent.clientX, i.clientY = i.originalEvent.clientY);
    },
    /**
     * Check if an event is a double click/tap
     * TODO: For touch gestures use a library (hammer.js) that takes in account other events
     * (touchmove and touchend). It should take in account tap duration and traveled distance
     *
     * @param  {Event}  evt
     * @param  {Event}  prevEvt Previous Event
     * @return {Boolean}
     */
    isDblClick: function(i, n) {
      if (i.detail === 2)
        return !0;
      if (n != null) {
        var o = i.timeStamp - n.timeStamp, a = Math.sqrt(
          Math.pow(i.clientX - n.clientX, 2) + Math.pow(i.clientY - n.clientY, 2)
        );
        return o < 250 && a < 10;
      }
      return !1;
    },
    /**
     * Returns current timestamp as an integer
     *
     * @return {Number}
     */
    now: Date.now || function() {
      return (/* @__PURE__ */ new Date()).getTime();
    },
    // From underscore.
    // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time. Normally, the throttled function will run
    // as much as it can, without ever going more than once per `wait` duration;
    // but if you'd like to disable the execution on the leading edge, pass
    // `{leading: false}`. To disable execution on the trailing edge, ditto.
    throttle: function(i, n, o) {
      var a = this, h, g, E, v = null, d = 0;
      o || (o = {});
      var s = function() {
        d = o.leading === !1 ? 0 : a.now(), v = null, E = i.apply(h, g), v || (h = g = null);
      };
      return function() {
        var c = a.now();
        !d && o.leading === !1 && (d = c);
        var f = n - (c - d);
        return h = this, g = arguments, f <= 0 || f > n ? (clearTimeout(v), v = null, d = c, E = i.apply(h, g), v || (h = g = null)) : !v && o.trailing !== !1 && (v = setTimeout(s, f)), E;
      };
    },
    /**
     * Create a requestAnimationFrame simulation
     *
     * @param  {Number|String} refreshRate
     * @return {Function}
     */
    createRequestAnimationFrame: function(i) {
      var n = null;
      return i !== "auto" && i < 60 && i > 1 && (n = Math.floor(1e3 / i)), n === null ? window.requestAnimationFrame || y(33) : y(n);
    }
  };
  function y(i) {
    return function(n) {
      window.setTimeout(n, i);
    };
  }
  return Dt;
}
var nt, me;
function Vt() {
  if (me) return nt;
  me = 1;
  var y = Lt(), i = "unknown";
  return document.documentMode && (i = "ie"), nt = {
    svgNS: "http://www.w3.org/2000/svg",
    xmlNS: "http://www.w3.org/XML/1998/namespace",
    xmlnsNS: "http://www.w3.org/2000/xmlns/",
    xlinkNS: "http://www.w3.org/1999/xlink",
    evNS: "http://www.w3.org/2001/xml-events",
    /**
     * Get svg dimensions: width and height
     *
     * @param  {SVGSVGElement} svg
     * @return {Object}     {width: 0, height: 0}
     */
    getBoundingClientRectNormalized: function(n) {
      if (n.clientWidth && n.clientHeight)
        return { width: n.clientWidth, height: n.clientHeight };
      if (n.getBoundingClientRect())
        return n.getBoundingClientRect();
      throw new Error("Cannot get BoundingClientRect for SVG.");
    },
    /**
     * Gets g element with class of "viewport" or creates it if it doesn't exist
     *
     * @param  {SVGSVGElement} svg
     * @return {SVGElement}     g (group) element
     */
    getOrCreateViewport: function(n, o) {
      var a = null;
      if (y.isElement(o) ? a = o : a = n.querySelector(o), !a) {
        var h = Array.prototype.slice.call(n.childNodes || n.children).filter(function(s) {
          return s.nodeName !== "defs" && s.nodeName !== "#text";
        });
        h.length === 1 && h[0].nodeName === "g" && h[0].getAttribute("transform") === null && (a = h[0]);
      }
      if (!a) {
        var g = "viewport-" + (/* @__PURE__ */ new Date()).toISOString().replace(/\D/g, "");
        a = document.createElementNS(this.svgNS, "g"), a.setAttribute("id", g);
        var E = n.childNodes || n.children;
        if (E && E.length > 0)
          for (var v = E.length; v > 0; v--)
            E[E.length - v].nodeName !== "defs" && a.appendChild(E[E.length - v]);
        n.appendChild(a);
      }
      var d = [];
      return a.getAttribute("class") && (d = a.getAttribute("class").split(" ")), ~d.indexOf("svg-pan-zoom_viewport") || (d.push("svg-pan-zoom_viewport"), a.setAttribute("class", d.join(" "))), a;
    },
    /**
     * Set SVG attributes
     *
     * @param  {SVGSVGElement} svg
     */
    setupSvgAttributes: function(n) {
      if (n.setAttribute("xmlns", this.svgNS), n.setAttributeNS(this.xmlnsNS, "xmlns:xlink", this.xlinkNS), n.setAttributeNS(this.xmlnsNS, "xmlns:ev", this.evNS), n.parentNode !== null) {
        var o = n.getAttribute("style") || "";
        o.toLowerCase().indexOf("overflow") === -1 && n.setAttribute("style", "overflow: hidden; " + o);
      }
    },
    /**
     * How long Internet Explorer takes to finish updating its display (ms).
     */
    internetExplorerRedisplayInterval: 300,
    /**
     * Forces the browser to redisplay all SVG elements that rely on an
     * element defined in a 'defs' section. It works globally, for every
     * available defs element on the page.
     * The throttling is intentionally global.
     *
     * This is only needed for IE. It is as a hack to make markers (and 'use' elements?)
     * visible after pan/zoom when there are multiple SVGs on the page.
     * See bug report: https://connect.microsoft.com/IE/feedback/details/781964/
     * also see svg-pan-zoom issue: https://github.com/bumbu/svg-pan-zoom/issues/62
     */
    refreshDefsGlobal: y.throttle(
      function() {
        for (var n = document.querySelectorAll("defs"), o = n.length, a = 0; a < o; a++) {
          var h = n[a];
          h.parentNode.insertBefore(h, h);
        }
      },
      nt ? nt.internetExplorerRedisplayInterval : null
    ),
    /**
     * Sets the current transform matrix of an element
     *
     * @param {SVGElement} element
     * @param {SVGMatrix} matrix  CTM
     * @param {SVGElement} defs
     */
    setCTM: function(n, o, a) {
      var h = this, g = "matrix(" + o.a + "," + o.b + "," + o.c + "," + o.d + "," + o.e + "," + o.f + ")";
      n.setAttributeNS(null, "transform", g), "transform" in n.style ? n.style.transform = g : "-ms-transform" in n.style ? n.style["-ms-transform"] = g : "-webkit-transform" in n.style && (n.style["-webkit-transform"] = g), i === "ie" && a && (a.parentNode.insertBefore(a, a), window.setTimeout(function() {
        h.refreshDefsGlobal();
      }, h.internetExplorerRedisplayInterval));
    },
    /**
     * Instantiate an SVGPoint object with given event coordinates
     *
     * @param {Event} evt
     * @param  {SVGSVGElement} svg
     * @return {SVGPoint}     point
     */
    getEventPoint: function(n, o) {
      var a = o.createSVGPoint();
      return y.mouseAndTouchNormalize(n, o), a.x = n.clientX, a.y = n.clientY, a;
    },
    /**
     * Get SVG center point
     *
     * @param  {SVGSVGElement} svg
     * @return {SVGPoint}
     */
    getSvgCenterPoint: function(n, o, a) {
      return this.createSVGPoint(n, o / 2, a / 2);
    },
    /**
     * Create a SVGPoint with given x and y
     *
     * @param  {SVGSVGElement} svg
     * @param  {Number} x
     * @param  {Number} y
     * @return {SVGPoint}
     */
    createSVGPoint: function(n, o, a) {
      var h = n.createSVGPoint();
      return h.x = o, h.y = a, h;
    }
  }, nt;
}
var kt, ve;
function ci() {
  if (ve) return kt;
  ve = 1;
  var y = Vt();
  return kt = {
    enable: function(i) {
      var n = i.svg.querySelector("defs");
      n || (n = document.createElementNS(y.svgNS, "defs"), i.svg.appendChild(n));
      var o = n.querySelector("style#svg-pan-zoom-controls-styles");
      if (!o) {
        var a = document.createElementNS(y.svgNS, "style");
        a.setAttribute("id", "svg-pan-zoom-controls-styles"), a.setAttribute("type", "text/css"), a.textContent = ".svg-pan-zoom-control { cursor: pointer; fill: black; fill-opacity: 0.333; } .svg-pan-zoom-control:hover { fill-opacity: 0.8; } .svg-pan-zoom-control-background { fill: white; fill-opacity: 0.5; } .svg-pan-zoom-control-background { fill-opacity: 0.8; }", n.appendChild(a);
      }
      var h = document.createElementNS(y.svgNS, "g");
      h.setAttribute("id", "svg-pan-zoom-controls"), h.setAttribute(
        "transform",
        "translate(" + (i.width - 70) + " " + (i.height - 76) + ") scale(0.75)"
      ), h.setAttribute("class", "svg-pan-zoom-control"), h.appendChild(this._createZoomIn(i)), h.appendChild(this._createZoomReset(i)), h.appendChild(this._createZoomOut(i)), i.svg.appendChild(h), i.controlIcons = h;
    },
    _createZoomIn: function(i) {
      var n = document.createElementNS(y.svgNS, "g");
      n.setAttribute("id", "svg-pan-zoom-zoom-in"), n.setAttribute("transform", "translate(30.5 5) scale(0.015)"), n.setAttribute("class", "svg-pan-zoom-control"), n.addEventListener(
        "click",
        function() {
          i.getPublicInstance().zoomIn();
        },
        !1
      ), n.addEventListener(
        "touchstart",
        function() {
          i.getPublicInstance().zoomIn();
        },
        !1
      );
      var o = document.createElementNS(y.svgNS, "rect");
      o.setAttribute("x", "0"), o.setAttribute("y", "0"), o.setAttribute("width", "1500"), o.setAttribute("height", "1400"), o.setAttribute("class", "svg-pan-zoom-control-background"), n.appendChild(o);
      var a = document.createElementNS(y.svgNS, "path");
      return a.setAttribute(
        "d",
        "M1280 576v128q0 26 -19 45t-45 19h-320v320q0 26 -19 45t-45 19h-128q-26 0 -45 -19t-19 -45v-320h-320q-26 0 -45 -19t-19 -45v-128q0 -26 19 -45t45 -19h320v-320q0 -26 19 -45t45 -19h128q26 0 45 19t19 45v320h320q26 0 45 19t19 45zM1536 1120v-960 q0 -119 -84.5 -203.5t-203.5 -84.5h-960q-119 0 -203.5 84.5t-84.5 203.5v960q0 119 84.5 203.5t203.5 84.5h960q119 0 203.5 -84.5t84.5 -203.5z"
      ), a.setAttribute("class", "svg-pan-zoom-control-element"), n.appendChild(a), n;
    },
    _createZoomReset: function(i) {
      var n = document.createElementNS(y.svgNS, "g");
      n.setAttribute("id", "svg-pan-zoom-reset-pan-zoom"), n.setAttribute("transform", "translate(5 35) scale(0.4)"), n.setAttribute("class", "svg-pan-zoom-control"), n.addEventListener(
        "click",
        function() {
          i.getPublicInstance().reset();
        },
        !1
      ), n.addEventListener(
        "touchstart",
        function() {
          i.getPublicInstance().reset();
        },
        !1
      );
      var o = document.createElementNS(
        y.svgNS,
        "rect"
      );
      o.setAttribute("x", "2"), o.setAttribute("y", "2"), o.setAttribute("width", "182"), o.setAttribute("height", "58"), o.setAttribute(
        "class",
        "svg-pan-zoom-control-background"
      ), n.appendChild(o);
      var a = document.createElementNS(
        y.svgNS,
        "path"
      );
      a.setAttribute(
        "d",
        "M33.051,20.632c-0.742-0.406-1.854-0.609-3.338-0.609h-7.969v9.281h7.769c1.543,0,2.701-0.188,3.473-0.562c1.365-0.656,2.048-1.953,2.048-3.891C35.032,22.757,34.372,21.351,33.051,20.632z"
      ), a.setAttribute(
        "class",
        "svg-pan-zoom-control-element"
      ), n.appendChild(a);
      var h = document.createElementNS(
        y.svgNS,
        "path"
      );
      return h.setAttribute(
        "d",
        "M170.231,0.5H15.847C7.102,0.5,0.5,5.708,0.5,11.84v38.861C0.5,56.833,7.102,61.5,15.847,61.5h154.384c8.745,0,15.269-4.667,15.269-10.798V11.84C185.5,5.708,178.976,0.5,170.231,0.5z M42.837,48.569h-7.969c-0.219-0.766-0.375-1.383-0.469-1.852c-0.188-0.969-0.289-1.961-0.305-2.977l-0.047-3.211c-0.03-2.203-0.41-3.672-1.142-4.406c-0.732-0.734-2.103-1.102-4.113-1.102h-7.05v13.547h-7.055V14.022h16.524c2.361,0.047,4.178,0.344,5.45,0.891c1.272,0.547,2.351,1.352,3.234,2.414c0.731,0.875,1.31,1.844,1.737,2.906s0.64,2.273,0.64,3.633c0,1.641-0.414,3.254-1.242,4.84s-2.195,2.707-4.102,3.363c1.594,0.641,2.723,1.551,3.387,2.73s0.996,2.98,0.996,5.402v2.32c0,1.578,0.063,2.648,0.19,3.211c0.19,0.891,0.635,1.547,1.333,1.969V48.569z M75.579,48.569h-26.18V14.022h25.336v6.117H56.454v7.336h16.781v6H56.454v8.883h19.125V48.569z M104.497,46.331c-2.44,2.086-5.887,3.129-10.34,3.129c-4.548,0-8.125-1.027-10.731-3.082s-3.909-4.879-3.909-8.473h6.891c0.224,1.578,0.662,2.758,1.316,3.539c1.196,1.422,3.246,2.133,6.15,2.133c1.739,0,3.151-0.188,4.236-0.562c2.058-0.719,3.087-2.055,3.087-4.008c0-1.141-0.504-2.023-1.512-2.648c-1.008-0.609-2.607-1.148-4.796-1.617l-3.74-0.82c-3.676-0.812-6.201-1.695-7.576-2.648c-2.328-1.594-3.492-4.086-3.492-7.477c0-3.094,1.139-5.664,3.417-7.711s5.623-3.07,10.036-3.07c3.685,0,6.829,0.965,9.431,2.895c2.602,1.93,3.966,4.73,4.093,8.402h-6.938c-0.128-2.078-1.057-3.555-2.787-4.43c-1.154-0.578-2.587-0.867-4.301-0.867c-1.907,0-3.428,0.375-4.565,1.125c-1.138,0.75-1.706,1.797-1.706,3.141c0,1.234,0.561,2.156,1.682,2.766c0.721,0.406,2.25,0.883,4.589,1.43l6.063,1.43c2.657,0.625,4.648,1.461,5.975,2.508c2.059,1.625,3.089,3.977,3.089,7.055C108.157,41.624,106.937,44.245,104.497,46.331z M139.61,48.569h-26.18V14.022h25.336v6.117h-18.281v7.336h16.781v6h-16.781v8.883h19.125V48.569z M170.337,20.14h-10.336v28.43h-7.266V20.14h-10.383v-6.117h27.984V20.14z"
      ), h.setAttribute(
        "class",
        "svg-pan-zoom-control-element"
      ), n.appendChild(h), n;
    },
    _createZoomOut: function(i) {
      var n = document.createElementNS(y.svgNS, "g");
      n.setAttribute("id", "svg-pan-zoom-zoom-out"), n.setAttribute("transform", "translate(30.5 70) scale(0.015)"), n.setAttribute("class", "svg-pan-zoom-control"), n.addEventListener(
        "click",
        function() {
          i.getPublicInstance().zoomOut();
        },
        !1
      ), n.addEventListener(
        "touchstart",
        function() {
          i.getPublicInstance().zoomOut();
        },
        !1
      );
      var o = document.createElementNS(y.svgNS, "rect");
      o.setAttribute("x", "0"), o.setAttribute("y", "0"), o.setAttribute("width", "1500"), o.setAttribute("height", "1400"), o.setAttribute("class", "svg-pan-zoom-control-background"), n.appendChild(o);
      var a = document.createElementNS(y.svgNS, "path");
      return a.setAttribute(
        "d",
        "M1280 576v128q0 26 -19 45t-45 19h-896q-26 0 -45 -19t-19 -45v-128q0 -26 19 -45t45 -19h896q26 0 45 19t19 45zM1536 1120v-960q0 -119 -84.5 -203.5t-203.5 -84.5h-960q-119 0 -203.5 84.5t-84.5 203.5v960q0 119 84.5 203.5t203.5 84.5h960q119 0 203.5 -84.5 t84.5 -203.5z"
      ), a.setAttribute("class", "svg-pan-zoom-control-element"), n.appendChild(a), n;
    },
    disable: function(i) {
      i.controlIcons && (i.controlIcons.parentNode.removeChild(i.controlIcons), i.controlIcons = null);
    }
  }, kt;
}
var Bt, ge;
function hi() {
  if (ge) return Bt;
  ge = 1;
  var y = Vt(), i = Lt(), n = function(o, a) {
    this.init(o, a);
  };
  return n.prototype.init = function(o, a) {
    this.viewport = o, this.options = a, this.originalState = { zoom: 1, x: 0, y: 0 }, this.activeState = { zoom: 1, x: 0, y: 0 }, this.updateCTMCached = i.proxy(this.updateCTM, this), this.requestAnimationFrame = i.createRequestAnimationFrame(
      this.options.refreshRate
    ), this.viewBox = { x: 0, y: 0, width: 0, height: 0 }, this.cacheViewBox();
    var h = this.processCTM();
    this.setCTM(h), this.updateCTM();
  }, n.prototype.cacheViewBox = function() {
    var o = this.options.svg.getAttribute("viewBox");
    if (o) {
      var a = o.split(/[\s\,]/).filter(function(g) {
        return g;
      }).map(parseFloat);
      this.viewBox.x = a[0], this.viewBox.y = a[1], this.viewBox.width = a[2], this.viewBox.height = a[3];
      var h = Math.min(
        this.options.width / this.viewBox.width,
        this.options.height / this.viewBox.height
      );
      this.activeState.zoom = h, this.activeState.x = (this.options.width - this.viewBox.width * h) / 2, this.activeState.y = (this.options.height - this.viewBox.height * h) / 2, this.updateCTMOnNextFrame(), this.options.svg.removeAttribute("viewBox");
    } else
      this.simpleViewBoxCache();
  }, n.prototype.simpleViewBoxCache = function() {
    var o = this.viewport.getBBox();
    this.viewBox.x = o.x, this.viewBox.y = o.y, this.viewBox.width = o.width, this.viewBox.height = o.height;
  }, n.prototype.getViewBox = function() {
    return i.extend({}, this.viewBox);
  }, n.prototype.processCTM = function() {
    var o = this.getCTM();
    if (this.options.fit || this.options.contain) {
      var a;
      this.options.fit ? a = Math.min(
        this.options.width / this.viewBox.width,
        this.options.height / this.viewBox.height
      ) : a = Math.max(
        this.options.width / this.viewBox.width,
        this.options.height / this.viewBox.height
      ), o.a = a, o.d = a, o.e = -this.viewBox.x * a, o.f = -this.viewBox.y * a;
    }
    if (this.options.center) {
      var h = (this.options.width - (this.viewBox.width + this.viewBox.x * 2) * o.a) * 0.5, g = (this.options.height - (this.viewBox.height + this.viewBox.y * 2) * o.a) * 0.5;
      o.e = h, o.f = g;
    }
    return this.originalState.zoom = o.a, this.originalState.x = o.e, this.originalState.y = o.f, o;
  }, n.prototype.getOriginalState = function() {
    return i.extend({}, this.originalState);
  }, n.prototype.getState = function() {
    return i.extend({}, this.activeState);
  }, n.prototype.getZoom = function() {
    return this.activeState.zoom;
  }, n.prototype.getRelativeZoom = function() {
    return this.activeState.zoom / this.originalState.zoom;
  }, n.prototype.computeRelativeZoom = function(o) {
    return o / this.originalState.zoom;
  }, n.prototype.getPan = function() {
    return { x: this.activeState.x, y: this.activeState.y };
  }, n.prototype.getCTM = function() {
    var o = this.options.svg.createSVGMatrix();
    return o.a = this.activeState.zoom, o.b = 0, o.c = 0, o.d = this.activeState.zoom, o.e = this.activeState.x, o.f = this.activeState.y, o;
  }, n.prototype.setCTM = function(o) {
    var a = this.isZoomDifferent(o), h = this.isPanDifferent(o);
    if (a || h) {
      if (a && (this.options.beforeZoom(
        this.getRelativeZoom(),
        this.computeRelativeZoom(o.a)
      ) === !1 ? (o.a = o.d = this.activeState.zoom, a = !1) : (this.updateCache(o), this.options.onZoom(this.getRelativeZoom()))), h) {
        var g = this.options.beforePan(this.getPan(), {
          x: o.e,
          y: o.f
        }), E = !1, v = !1;
        g === !1 ? (o.e = this.getPan().x, o.f = this.getPan().y, E = v = !0) : i.isObject(g) && (g.x === !1 ? (o.e = this.getPan().x, E = !0) : i.isNumber(g.x) && (o.e = g.x), g.y === !1 ? (o.f = this.getPan().y, v = !0) : i.isNumber(g.y) && (o.f = g.y)), E && v || !this.isPanDifferent(o) ? h = !1 : (this.updateCache(o), this.options.onPan(this.getPan()));
      }
      (a || h) && this.updateCTMOnNextFrame();
    }
  }, n.prototype.isZoomDifferent = function(o) {
    return this.activeState.zoom !== o.a;
  }, n.prototype.isPanDifferent = function(o) {
    return this.activeState.x !== o.e || this.activeState.y !== o.f;
  }, n.prototype.updateCache = function(o) {
    this.activeState.zoom = o.a, this.activeState.x = o.e, this.activeState.y = o.f;
  }, n.prototype.pendingUpdate = !1, n.prototype.updateCTMOnNextFrame = function() {
    this.pendingUpdate || (this.pendingUpdate = !0, this.requestAnimationFrame.call(window, this.updateCTMCached));
  }, n.prototype.updateCTM = function() {
    var o = this.getCTM();
    y.setCTM(this.viewport, o, this.defs), this.pendingUpdate = !1, this.options.onUpdatedCTM && this.options.onUpdatedCTM(o);
  }, Bt = function(o, a) {
    return new n(o, a);
  }, Bt;
}
var Ut, ye;
function ui() {
  if (ye) return Ut;
  ye = 1;
  var y = li(), i = ci(), n = Lt(), o = Vt(), a = hi(), h = function(s, c) {
    this.init(s, c);
  }, g = {
    viewportSelector: ".svg-pan-zoom_viewport",
    // Viewport selector. Can be querySelector string or SVGElement
    panEnabled: !0,
    // enable or disable panning (default enabled)
    controlIconsEnabled: !1,
    // insert icons to give user an option in addition to mouse events to control pan/zoom (default disabled)
    zoomEnabled: !0,
    // enable or disable zooming (default enabled)
    dblClickZoomEnabled: !0,
    // enable or disable zooming by double clicking (default enabled)
    mouseWheelZoomEnabled: !0,
    // enable or disable zooming by mouse wheel (default enabled)
    preventMouseEventsDefault: !0,
    // enable or disable preventDefault for mouse events
    zoomScaleSensitivity: 0.1,
    // Zoom sensitivity
    minZoom: 0.5,
    // Minimum Zoom level
    maxZoom: 10,
    // Maximum Zoom level
    fit: !0,
    // enable or disable viewport fit in SVG (default true)
    contain: !1,
    // enable or disable viewport contain the svg (default false)
    center: !0,
    // enable or disable viewport centering in SVG (default true)
    refreshRate: "auto",
    // Maximum number of frames per second (altering SVG's viewport)
    beforeZoom: null,
    onZoom: null,
    beforePan: null,
    onPan: null,
    customEventsHandler: null,
    eventsListenerElement: null,
    onUpdatedCTM: null
  }, E = { passive: !0 };
  h.prototype.init = function(s, c) {
    var f = this;
    this.svg = s, this.defs = s.querySelector("defs"), o.setupSvgAttributes(this.svg), this.options = n.extend(n.extend({}, g), c), this.state = "none";
    var w = o.getBoundingClientRectNormalized(
      s
    );
    this.width = w.width, this.height = w.height, this.viewport = a(
      o.getOrCreateViewport(this.svg, this.options.viewportSelector),
      {
        svg: this.svg,
        width: this.width,
        height: this.height,
        fit: this.options.fit,
        contain: this.options.contain,
        center: this.options.center,
        refreshRate: this.options.refreshRate,
        // Put callbacks into functions as they can change through time
        beforeZoom: function(p, S) {
          if (f.viewport && f.options.beforeZoom)
            return f.options.beforeZoom(p, S);
        },
        onZoom: function(p) {
          if (f.viewport && f.options.onZoom)
            return f.options.onZoom(p);
        },
        beforePan: function(p, S) {
          if (f.viewport && f.options.beforePan)
            return f.options.beforePan(p, S);
        },
        onPan: function(p) {
          if (f.viewport && f.options.onPan)
            return f.options.onPan(p);
        },
        onUpdatedCTM: function(p) {
          if (f.viewport && f.options.onUpdatedCTM)
            return f.options.onUpdatedCTM(p);
        }
      }
    );
    var T = this.getPublicInstance();
    T.setBeforeZoom(this.options.beforeZoom), T.setOnZoom(this.options.onZoom), T.setBeforePan(this.options.beforePan), T.setOnPan(this.options.onPan), T.setOnUpdatedCTM(this.options.onUpdatedCTM), this.options.controlIconsEnabled && i.enable(this), this.lastMouseWheelEventTime = Date.now(), this.setupHandlers();
  }, h.prototype.setupHandlers = function() {
    var s = this, c = null;
    if (this.eventListeners = {
      // Mouse down group
      mousedown: function(p) {
        var S = s.handleMouseDown(p, c);
        return c = p, S;
      },
      touchstart: function(p) {
        var S = s.handleMouseDown(p, c);
        return c = p, S;
      },
      // Mouse up group
      mouseup: function(p) {
        return s.handleMouseUp(p);
      },
      touchend: function(p) {
        return s.handleMouseUp(p);
      },
      // Mouse move group
      mousemove: function(p) {
        return s.handleMouseMove(p);
      },
      touchmove: function(p) {
        return s.handleMouseMove(p);
      },
      // Mouse leave group
      mouseleave: function(p) {
        return s.handleMouseUp(p);
      },
      touchleave: function(p) {
        return s.handleMouseUp(p);
      },
      touchcancel: function(p) {
        return s.handleMouseUp(p);
      }
    }, this.options.customEventsHandler != null) {
      this.options.customEventsHandler.init({
        svgElement: this.svg,
        eventsListenerElement: this.options.eventsListenerElement,
        instance: this.getPublicInstance()
      });
      var f = this.options.customEventsHandler.haltEventListeners;
      if (f && f.length)
        for (var w = f.length - 1; w >= 0; w--)
          this.eventListeners.hasOwnProperty(f[w]) && delete this.eventListeners[f[w]];
    }
    for (var T in this.eventListeners)
      (this.options.eventsListenerElement || this.svg).addEventListener(
        T,
        this.eventListeners[T],
        this.options.preventMouseEventsDefault ? !1 : E
      );
    this.options.mouseWheelZoomEnabled && (this.options.mouseWheelZoomEnabled = !1, this.enableMouseWheelZoom());
  }, h.prototype.enableMouseWheelZoom = function() {
    if (!this.options.mouseWheelZoomEnabled) {
      var s = this;
      this.wheelListener = function(f) {
        return s.handleMouseWheel(f);
      };
      var c = !this.options.preventMouseEventsDefault;
      y.on(
        this.options.eventsListenerElement || this.svg,
        this.wheelListener,
        c
      ), this.options.mouseWheelZoomEnabled = !0;
    }
  }, h.prototype.disableMouseWheelZoom = function() {
    if (this.options.mouseWheelZoomEnabled) {
      var s = !this.options.preventMouseEventsDefault;
      y.off(
        this.options.eventsListenerElement || this.svg,
        this.wheelListener,
        s
      ), this.options.mouseWheelZoomEnabled = !1;
    }
  }, h.prototype.handleMouseWheel = function(s) {
    if (!(!this.options.zoomEnabled || this.state !== "none")) {
      this.options.preventMouseEventsDefault && (s.preventDefault ? s.preventDefault() : s.returnValue = !1);
      var c = s.deltaY || 1, f = Date.now() - this.lastMouseWheelEventTime, w = 3 + Math.max(0, 30 - f);
      this.lastMouseWheelEventTime = Date.now(), "deltaMode" in s && s.deltaMode === 0 && s.wheelDelta && (c = s.deltaY === 0 ? 0 : Math.abs(s.wheelDelta) / s.deltaY), c = -0.3 < c && c < 0.3 ? c : (c > 0 ? 1 : -1) * Math.log(Math.abs(c) + 10) / w;
      var T = this.svg.getScreenCTM().inverse(), p = o.getEventPoint(s, this.svg).matrixTransform(
        T
      ), S = Math.pow(1 + this.options.zoomScaleSensitivity, -1 * c);
      this.zoomAtPoint(S, p);
    }
  }, h.prototype.zoomAtPoint = function(s, c, f) {
    var w = this.viewport.getOriginalState();
    f ? (s = Math.max(
      this.options.minZoom * w.zoom,
      Math.min(this.options.maxZoom * w.zoom, s)
    ), s = s / this.getZoom()) : this.getZoom() * s < this.options.minZoom * w.zoom ? s = this.options.minZoom * w.zoom / this.getZoom() : this.getZoom() * s > this.options.maxZoom * w.zoom && (s = this.options.maxZoom * w.zoom / this.getZoom());
    var T = this.viewport.getCTM(), p = c.matrixTransform(T.inverse()), S = this.svg.createSVGMatrix().translate(p.x, p.y).scale(s).translate(-p.x, -p.y), P = T.multiply(S);
    P.a !== T.a && this.viewport.setCTM(P);
  }, h.prototype.zoom = function(s, c) {
    this.zoomAtPoint(
      s,
      o.getSvgCenterPoint(this.svg, this.width, this.height),
      c
    );
  }, h.prototype.publicZoom = function(s, c) {
    c && (s = this.computeFromRelativeZoom(s)), this.zoom(s, c);
  }, h.prototype.publicZoomAtPoint = function(s, c, f) {
    if (f && (s = this.computeFromRelativeZoom(s)), n.getType(c) !== "SVGPoint")
      if ("x" in c && "y" in c)
        c = o.createSVGPoint(this.svg, c.x, c.y);
      else
        throw new Error("Given point is invalid");
    this.zoomAtPoint(s, c, f);
  }, h.prototype.getZoom = function() {
    return this.viewport.getZoom();
  }, h.prototype.getRelativeZoom = function() {
    return this.viewport.getRelativeZoom();
  }, h.prototype.computeFromRelativeZoom = function(s) {
    return s * this.viewport.getOriginalState().zoom;
  }, h.prototype.resetZoom = function() {
    var s = this.viewport.getOriginalState();
    this.zoom(s.zoom, !0);
  }, h.prototype.resetPan = function() {
    this.pan(this.viewport.getOriginalState());
  }, h.prototype.reset = function() {
    this.resetZoom(), this.resetPan();
  }, h.prototype.handleDblClick = function(s) {
    if (this.options.preventMouseEventsDefault && (s.preventDefault ? s.preventDefault() : s.returnValue = !1), this.options.controlIconsEnabled) {
      var c = s.target.getAttribute("class") || "";
      if (c.indexOf("svg-pan-zoom-control") > -1)
        return !1;
    }
    var f;
    s.shiftKey ? f = 1 / ((1 + this.options.zoomScaleSensitivity) * 2) : f = (1 + this.options.zoomScaleSensitivity) * 2;
    var w = o.getEventPoint(s, this.svg).matrixTransform(
      this.svg.getScreenCTM().inverse()
    );
    this.zoomAtPoint(f, w);
  }, h.prototype.handleMouseDown = function(s, c) {
    this.options.preventMouseEventsDefault && (s.preventDefault ? s.preventDefault() : s.returnValue = !1), n.mouseAndTouchNormalize(s, this.svg), this.options.dblClickZoomEnabled && n.isDblClick(s, c) ? this.handleDblClick(s) : (this.state = "pan", this.firstEventCTM = this.viewport.getCTM(), this.stateOrigin = o.getEventPoint(s, this.svg).matrixTransform(
      this.firstEventCTM.inverse()
    ));
  }, h.prototype.handleMouseMove = function(s) {
    if (this.options.preventMouseEventsDefault && (s.preventDefault ? s.preventDefault() : s.returnValue = !1), this.state === "pan" && this.options.panEnabled) {
      var c = o.getEventPoint(s, this.svg).matrixTransform(
        this.firstEventCTM.inverse()
      ), f = this.firstEventCTM.translate(
        c.x - this.stateOrigin.x,
        c.y - this.stateOrigin.y
      );
      this.viewport.setCTM(f);
    }
  }, h.prototype.handleMouseUp = function(s) {
    this.options.preventMouseEventsDefault && (s.preventDefault ? s.preventDefault() : s.returnValue = !1), this.state === "pan" && (this.state = "none");
  }, h.prototype.fit = function() {
    var s = this.viewport.getViewBox(), c = Math.min(
      this.width / s.width,
      this.height / s.height
    );
    this.zoom(c, !0);
  }, h.prototype.contain = function() {
    var s = this.viewport.getViewBox(), c = Math.max(
      this.width / s.width,
      this.height / s.height
    );
    this.zoom(c, !0);
  }, h.prototype.center = function() {
    var s = this.viewport.getViewBox(), c = (this.width - (s.width + s.x * 2) * this.getZoom()) * 0.5, f = (this.height - (s.height + s.y * 2) * this.getZoom()) * 0.5;
    this.getPublicInstance().pan({ x: c, y: f });
  }, h.prototype.updateBBox = function() {
    this.viewport.simpleViewBoxCache();
  }, h.prototype.pan = function(s) {
    var c = this.viewport.getCTM();
    c.e = s.x, c.f = s.y, this.viewport.setCTM(c);
  }, h.prototype.panBy = function(s) {
    var c = this.viewport.getCTM();
    c.e += s.x, c.f += s.y, this.viewport.setCTM(c);
  }, h.prototype.getPan = function() {
    var s = this.viewport.getState();
    return { x: s.x, y: s.y };
  }, h.prototype.resize = function() {
    var s = o.getBoundingClientRectNormalized(
      this.svg
    );
    this.width = s.width, this.height = s.height;
    var c = this.viewport;
    c.options.width = this.width, c.options.height = this.height, c.processCTM(), this.options.controlIconsEnabled && (this.getPublicInstance().disableControlIcons(), this.getPublicInstance().enableControlIcons());
  }, h.prototype.destroy = function() {
    var s = this;
    this.beforeZoom = null, this.onZoom = null, this.beforePan = null, this.onPan = null, this.onUpdatedCTM = null, this.options.customEventsHandler != null && this.options.customEventsHandler.destroy({
      svgElement: this.svg,
      eventsListenerElement: this.options.eventsListenerElement,
      instance: this.getPublicInstance()
    });
    for (var c in this.eventListeners)
      (this.options.eventsListenerElement || this.svg).removeEventListener(
        c,
        this.eventListeners[c],
        this.options.preventMouseEventsDefault ? !1 : E
      );
    this.disableMouseWheelZoom(), this.getPublicInstance().disableControlIcons(), this.reset(), v = v.filter(function(f) {
      return f.svg !== s.svg;
    }), delete this.options, delete this.viewport, delete this.publicInstance, delete this.pi, this.getPublicInstance = function() {
      return null;
    };
  }, h.prototype.getPublicInstance = function() {
    var s = this;
    return this.publicInstance || (this.publicInstance = this.pi = {
      // Pan
      enablePan: function() {
        return s.options.panEnabled = !0, s.pi;
      },
      disablePan: function() {
        return s.options.panEnabled = !1, s.pi;
      },
      isPanEnabled: function() {
        return !!s.options.panEnabled;
      },
      pan: function(c) {
        return s.pan(c), s.pi;
      },
      panBy: function(c) {
        return s.panBy(c), s.pi;
      },
      getPan: function() {
        return s.getPan();
      },
      // Pan event
      setBeforePan: function(c) {
        return s.options.beforePan = c === null ? null : n.proxy(c, s.publicInstance), s.pi;
      },
      setOnPan: function(c) {
        return s.options.onPan = c === null ? null : n.proxy(c, s.publicInstance), s.pi;
      },
      // Zoom and Control Icons
      enableZoom: function() {
        return s.options.zoomEnabled = !0, s.pi;
      },
      disableZoom: function() {
        return s.options.zoomEnabled = !1, s.pi;
      },
      isZoomEnabled: function() {
        return !!s.options.zoomEnabled;
      },
      enableControlIcons: function() {
        return s.options.controlIconsEnabled || (s.options.controlIconsEnabled = !0, i.enable(s)), s.pi;
      },
      disableControlIcons: function() {
        return s.options.controlIconsEnabled && (s.options.controlIconsEnabled = !1, i.disable(s)), s.pi;
      },
      isControlIconsEnabled: function() {
        return !!s.options.controlIconsEnabled;
      },
      // Double click zoom
      enableDblClickZoom: function() {
        return s.options.dblClickZoomEnabled = !0, s.pi;
      },
      disableDblClickZoom: function() {
        return s.options.dblClickZoomEnabled = !1, s.pi;
      },
      isDblClickZoomEnabled: function() {
        return !!s.options.dblClickZoomEnabled;
      },
      // Mouse wheel zoom
      enableMouseWheelZoom: function() {
        return s.enableMouseWheelZoom(), s.pi;
      },
      disableMouseWheelZoom: function() {
        return s.disableMouseWheelZoom(), s.pi;
      },
      isMouseWheelZoomEnabled: function() {
        return !!s.options.mouseWheelZoomEnabled;
      },
      // Zoom scale and bounds
      setZoomScaleSensitivity: function(c) {
        return s.options.zoomScaleSensitivity = c, s.pi;
      },
      setMinZoom: function(c) {
        return s.options.minZoom = c, s.pi;
      },
      setMaxZoom: function(c) {
        return s.options.maxZoom = c, s.pi;
      },
      // Zoom event
      setBeforeZoom: function(c) {
        return s.options.beforeZoom = c === null ? null : n.proxy(c, s.publicInstance), s.pi;
      },
      setOnZoom: function(c) {
        return s.options.onZoom = c === null ? null : n.proxy(c, s.publicInstance), s.pi;
      },
      // Zooming
      zoom: function(c) {
        return s.publicZoom(c, !0), s.pi;
      },
      zoomBy: function(c) {
        return s.publicZoom(c, !1), s.pi;
      },
      zoomAtPoint: function(c, f) {
        return s.publicZoomAtPoint(c, f, !0), s.pi;
      },
      zoomAtPointBy: function(c, f) {
        return s.publicZoomAtPoint(c, f, !1), s.pi;
      },
      zoomIn: function() {
        return this.zoomBy(1 + s.options.zoomScaleSensitivity), s.pi;
      },
      zoomOut: function() {
        return this.zoomBy(1 / (1 + s.options.zoomScaleSensitivity)), s.pi;
      },
      getZoom: function() {
        return s.getRelativeZoom();
      },
      // CTM update
      setOnUpdatedCTM: function(c) {
        return s.options.onUpdatedCTM = c === null ? null : n.proxy(c, s.publicInstance), s.pi;
      },
      // Reset
      resetZoom: function() {
        return s.resetZoom(), s.pi;
      },
      resetPan: function() {
        return s.resetPan(), s.pi;
      },
      reset: function() {
        return s.reset(), s.pi;
      },
      // Fit, Contain and Center
      fit: function() {
        return s.fit(), s.pi;
      },
      contain: function() {
        return s.contain(), s.pi;
      },
      center: function() {
        return s.center(), s.pi;
      },
      // Size and Resize
      updateBBox: function() {
        return s.updateBBox(), s.pi;
      },
      resize: function() {
        return s.resize(), s.pi;
      },
      getSizes: function() {
        return {
          width: s.width,
          height: s.height,
          realZoom: s.getZoom(),
          viewBox: s.viewport.getViewBox()
        };
      },
      // Destroy
      destroy: function() {
        return s.destroy(), s.pi;
      }
    }), this.publicInstance;
  };
  var v = [], d = function(s, c) {
    var f = n.getSvg(s);
    if (f === null)
      return null;
    for (var w = v.length - 1; w >= 0; w--)
      if (v[w].svg === f)
        return v[w].instance.getPublicInstance();
    return v.push({
      svg: f,
      instance: new h(f, c)
    }), v[v.length - 1].instance.getPublicInstance();
  };
  return Ut = d, Ut;
}
var fi = ui();
const pi = /* @__PURE__ */ Ee(fi);
class di {
  constructor(i, n) {
    Z(this, "panZoomSVG");
    Z(this, "options", we);
    const o = i.contentDocument.getElementById("svgDisplayed");
    Object.assign(this.options, n);
    let a = null, h = (E, v) => {
      let d = this.panZoomSVG.getSizes(), s = -(d.viewBox.width * d.realZoom - d.width), c = 0, f = -(d.viewBox.height * d.realZoom - d.height), w = 0;
      const T = {
        x: !0,
        y: !0
      };
      return d.viewBox.width * d.realZoom > d.width ? (v.x < s && (T.x = s), v.x > c && (T.x = c)) : T.x = (d.width - d.viewBox.width * d.realZoom) / 2, d.viewBox.height * d.realZoom > d.height ? (v.y < f && (T.y = f), v.y > w && (T.y = w)) : T.y = (d.height - d.viewBox.height * d.realZoom) / 2, T;
    }, g = {
      // Disable touch events handling from svgpanzoom, they will be handled by Hammerjs
      haltEventListeners: [
        "touchstart",
        "touchend",
        "touchmove",
        "touchleave",
        "touchcancel"
      ],
      // Setup Hammerjs events listeners
      init: (E) => {
        let v = E.instance, d = 1, s = 0, c = 0;
        a = new Et(E.svgElement, {
          inputClass: Et.SUPPORT_POINTER_EVENTS ? Et.PointerEventInput : Et.TouchInput
        }), a.get("pinch").set({ enable: !0 }), a.on("doubletap", (f) => {
          v.zoomIn();
        }), a.on("panstart panmove", (f) => {
          f.type === "panstart" && (s = 0, c = 0), v.panBy({ x: f.deltaX - s, y: f.deltaY - c }), s = f.deltaX, c = f.deltaY;
        }), a.on("pinchstart pinchmove", (f) => {
          f.type === "pinchstart" && (d = v.getZoom(), v.zoomAtPoint(d * f.scale, {
            x: f.center.x,
            y: f.center.y
          })), v.zoomAtPoint(d * f.scale, {
            x: f.center.x,
            y: f.center.y
          });
        }), E.svgElement.addEventListener("touchmove", (f) => {
          f.preventDefault();
        });
      },
      destroy: () => {
        a && a.destroy();
      }
    };
    if (this.panZoomSVG = pi(o, {
      zoomScaleSensitivity: 0.1,
      minZoom: 1,
      maxZoom: 10,
      center: !1,
      beforePan: h,
      customEventsHandler: g,
      mouseWheelZoomEnabled: !n.requireCtrlOrMetaKeyToZoom
    }), n.requireCtrlOrMetaKeyToZoom) {
      let E = function() {
        console.log("showCtrlRequiredWarning"), d && (d.style.opacity = "0.5");
      }, v = function() {
        if (console.log("hideCtrlRequiredWarning"), !!d) {
          d.style.opacity = "0", d.style.display = "none";
          try {
            sessionStorage.setItem("pacifa-knowsHowToZoomOnMap", "yes");
          } catch {
          }
        }
      };
      o.addEventListener("wheel", (c) => {
        c.ctrlKey || c.metaKey ? (c.preventDefault(), c.stopPropagation(), c.deltaY < 0 ? this.panZoomSVG.zoomIn() : this.panZoomSVG.zoomOut(), v()) : E();
      });
      let d;
      const s = i.contentDocument;
      if (!n.requireCtrlOrMetaKeyToZoomWarning || !s)
        return;
      try {
        if (sessionStorage.getItem("pacifa-knowsHowToZoomOnMap"))
          return;
      } catch {
      }
      d = s.createElement("div"), d.textContent = this.options.requireCtrlOrMetaKeyToZoomWarning, d.id = "requireCtrlOrMetaKeyToZoomWarning", d.style.opacity = "0", s.body.appendChild(d), s.body.addEventListener("mouseleave", function() {
        d.style.opacity = "0";
      });
    }
  }
  updateOnResize() {
    this.panZoomSVG.updateBBox(), this.panZoomSVG.resize(), this.panZoomSVG.fit(), this.panZoomSVG.center();
  }
  destroy() {
    this.panZoomSVG.destroy();
  }
}
const Te = `
  <div id="loader">
    <div class="loader-content"></div>
    <style>
      #loader {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
      }
      .loader-content {
        margin: auto;
        width: 80px;
        height: 80px;
        aspect-ratio: 1;
        border-radius: 50%;
        background: 
          radial-gradient(farthest-side,#ffa516 94%,#0000) top/8px 8px no-repeat,
          conic-gradient(#0000 30%,#ffa516);
        -webkit-mask: radial-gradient(farthest-side,#0000 calc(100% - 8px),#000 0);
        animation: l13 1s infinite linear;
      }
      @keyframes l13{ 
        100%{transform: rotate(1turn)}
      }
    </style>
  </div>`, Rt = `
<html>
<head>
  <style>
    html, body {
      margin: 0;
      padding: 0;
      height: 100%;
      width: 100%;
    }
  </style>
</head>
<body>
${Te}
</body>
</html>
`, we = {
  apiUrl: "https://apiv2.pacifa3d.com",
  requireCtrlOrMetaKeyToZoom: !1,
  showZoomButtons: !1,
  fewerPanoControls: !1,
  requireCtrlOrMetaKeyToZoomWarning: "Press ctrl/⌘ while scrolling to zoom",
  recenterOnWidowResize: !0,
  customCSS: ""
};
function mi(y) {
  let i = 5381;
  for (let n = 0; n < y.length; n++)
    i = i * 33 ^ y.charCodeAt(n);
  return (i >>> 0).toString(36).slice(0, 8);
}
class gi {
  /**
   * @param elementId - The ID of the DOM element where viewer will be initialized.
   * @param puid - The unique identifier of the venue
   * @param options - Options
   *
   * @throws {Error} If the DOM element with the specified `elementId` is not found.
   *
   * @category General Use
   */
  constructor(i, n, o) {
    /**
     * The DOM element containing the viewer
     *
     * @category General Use
     */
    Z(this, "containerEl");
    /**
     * The unique identifier of the venue
     *
     * @category General Use
     */
    Z(this, "puid");
    Z(this, "iframeEl");
    Z(this, "api");
    Z(this, "controls", null);
    Z(this, "callbacks", {});
    Z(this, "providerName");
    Z(this, "options", we);
    Object.assign(this.options, o), this.puid = n, this.api = new si(this.options.apiUrl);
    let a = document.getElementById(i);
    if (!a)
      throw new Error(`element #${i} not found`);
    this.containerEl = a, this.resetIframe(), o.recenterOnWidowResize && window.addEventListener("resize", () => this.updateOnResize());
    const h = {
      OnShowTooltipStand: (g, E, v) => {
        this.emit("standMouseMove", v, {
          clientX: g.clientX,
          clientY: g.clientY
        });
      },
      OnStandClicked: (g, E) => {
        this.emit("standClicked", E);
      },
      OnShowTooltipBlock: (g, E, v) => {
        this.emit("blockMouseMove", v, {
          clientX: g.clientX,
          clientY: g.clientY
        });
      },
      OnBlockClicked: (g, E) => {
        this.emit("blockClicked", E);
      },
      OnShowTooltipSeat: (g, E, v, d, s) => {
        this.emit("seatMouseMove", { seatId: s, blockId: v, row: d }, { clientX: g.clientX, clientY: g.clientY });
      },
      OnSeatClicked: (g, E, v, d) => {
        this.emit("seatClicked", { seatId: d, blockId: E, row: v });
      },
      OnHideTooltip: (g) => {
        g.getAttribute("data-seat") ? this.emit("seatMouseLeave", g.getAttribute("data-seat") || "") : g.getAttribute("data-block") ? this.emit("blockMouseLeave", g.getAttribute("data-block") || "") : g.getAttribute("data-stand") && this.emit("standMouseLeave", g.getAttribute("data-stand") || "");
      }
    };
    this.providerName = "Pacifa3d_" + i.replace(/[^a-zA-Z0-9_]/g, "") + "_" + mi(i), window[this.providerName] = h;
  }
  /**
   * Display the venue top view
   *
   * @param options - Options
   *
   * @return A promise when the top view is loaded
   *
   * @category General Use
   */
  async displayTopView(i = {}) {
    (i.blockIds !== void 0 || i.standIds !== void 0) && i.included === void 0 && (i.included = !0), await this.resetIframe(Rt);
    let n = await this.api.getTopView(this.puid, this.providerName, i), o = await this.api.getContent(n);
    o = this.cleanContent(o), await this.resetIframe(o), this.iframeEl.contentDocument.getElementById("loader").style.display = "none", this.iframeEl.contentDocument.getElementById("svgDisplayed").querySelectorAll("polygon").forEach((h) => {
      var E, v;
      const g = /OnShowTooltip(Block|Stand).+['"]([^"']+)['"]/.exec(((E = h.onmousemove) == null ? void 0 : E.toString()) || "");
      if (g) {
        const d = g[1].toLowerCase(), s = g[2];
        h.setAttribute(`data-${d}`, s);
      } else
        console.error("Cannot find block id", (v = h.onmousemove) == null ? void 0 : v.toString());
    });
  }
  /**
   * Display a stand top view
   *
   * @param standId - id of the stand
   * @param options - Options
   * @return A promise when the stand view is loaded
   *
   * @category General Use
   */
  async displayStandView(i, n = {}) {
    n.blockIds !== void 0 && n.included === void 0 && (n.included = !0), this.resetIframe(Rt);
    let o = await this.api.getStand(this.puid, i, this.providerName, n), a = await this.api.getContent(o);
    a = this.cleanContent(a), await this.resetIframe(a), this.iframeEl.contentDocument.getElementById("loader").style.display = "none", this.iframeEl.contentDocument.getElementById("svgDisplayed").querySelectorAll("polygon").forEach((g) => {
      var v;
      const E = /['"]([^"]+)['"]\)/.exec(((v = g.onmousemove) == null ? void 0 : v.toString()) || "");
      if (E) {
        const d = E[1];
        g.setAttribute("data-block", d);
      } else
        console.error("Cannot find block id");
    });
  }
  /**
   * Display a block top view
   *
   * @param blockId - id of the block
   * @param options - Options
   * @return A promise when the block view is loaded
   *
   * @category General Use
   */
  async displayBlockView(i, n = {}) {
    n.seatIds !== void 0 && n.included === void 0 && (n.included = !0), this.resetIframe(Rt);
    let o = await this.api.getBlock(this.puid, i, this.providerName, n), a = await this.api.getContent(o);
    a = this.cleanContent(a), await this.resetIframe(a), this.iframeEl.contentDocument.getElementById("loader").style.display = "none", this.iframeEl.contentDocument.getElementById("svgDisplayed").querySelectorAll("polygon").forEach((g) => {
      var v;
      const E = /['"]([^"]+)['"]\)/.exec(((v = g.onmousemove) == null ? void 0 : v.toString()) || "");
      if (E) {
        const d = E[1];
        g.setAttribute("data-seat", d);
      } else
        console.error("Cannot find seat id");
    });
  }
  /**
   * Display the panoramic view of the stand `standId`.
   *
   * @param standId - id of the stand
   * @param el - The DOM element which will contain the panoramic view
   *
   * @category General Use
   */
  async displayStandPano(i, n) {
    let o = await this.api.getStandPanoUrl(this.puid, i);
    await this.displayPano(o, n);
  }
  /**
   * Display the panoramic view of the block `blockId`.
   *
   * @param blockId - id of the block
   * @param el - The DOM element which will contain the panoramic view
   *
   * @category General Use
   */
  async displayBlockPano(i, n) {
    let o = await this.api.getBlockPanoUrl(this.puid, i);
    await this.displayPano(o, n);
  }
  /**
   * Display the panoramic view of the seat `seatId`.
   *
   * @param blockId - id of the block containing the seat
   * @param seatId - id of the seat
   * @param el - The DOM element which will contain the panoramic view
   *
   * @category General Use
   */
  async displaySeatPano(i, n, o) {
    let a = await this.api.getSeatPanoUrl(this.puid, i, n);
    await this.displayPano(a, o);
  }
  async displayPano(i, n) {
    const o = document.createElement("iframe");
    return this.options.fewerPanoControls && (i += (i.includes("?") ? "&" : "?") + "onlyfs=true"), o.src = i, o.width = "100%", o.height = "100%", o.allowFullscreen = !0, n.replaceChildren(), n.appendChild(o), await new Promise((a, h) => {
      o.addEventListener("load", () => {
        a();
      }, { once: !0 });
    });
  }
  /**
     * Display the preview image for the panoramic view of the stand `standId`.
   * Resolves if loading worked, rejects otherwise
     *
     * @param standId - id of the stand
     * @param el - The DOM element whose content will be replaced by an img tag
     *
     * @category General Use
     */
  async displayStandPanoPreview(i, n) {
    const o = await this.api.getStandPanoPreview(this.puid, i);
    return this.displayImage(o, n);
  }
  /**
   * Display the preview image for the panoramic view of the block `blockId`.
   * Resolves if loading worked, rejects otherwise
   *
   * @param blockId - id of the block
   * @param el - The DOM element whose content will be replaced by an img tag
   *
   * @category General Use
   */
  async displayBlockPanoPreview(i, n) {
    const o = await this.api.getBlockPanoPreview(this.puid, i);
    return this.displayImage(o, n);
  }
  /**
   * Display the preview image for the panoramic view of the seat `seatId`.
   * Resolves if loading worked, rejects otherwise
   *
   * @param blockId - id of the block containing the seat
   * @param seatId - id of the seat
   * @param el - The DOM element whose content will be replaced by an img tag
   *
   * @category General Use
   */
  async displaySeatPanoPreview(i, n, o) {
    const a = await this.api.getSeatPanoPreview(this.puid, i, n);
    return this.displayImage(a, o);
  }
  async displayImage(i, n) {
    const o = document.createElement("img");
    o.src = i, o.setAttribute("alt", ""), await new Promise((a, h) => {
      o.addEventListener("load", () => {
        a(void 0);
      }, { once: !0 }), o.addEventListener("error", () => {
        h();
      }, { once: !0 });
    }), n.replaceChildren(), n.appendChild(o);
  }
  /**
   * Hide the panoramic view linked to the DOM element `el`
   *
   * @param el - The DOM element which contains the panoramic view
   *
   * @category General Use
   */
  hidePano(i) {
    i.innerHTML = "";
  }
  /**
   * @return The list of block ids
   *
   * @category Data
   */
  getBlockIds(i) {
    return this.api.getBlockIds(this.puid, i);
  }
  /**
   * @return The list of seat ids
   *
   * @category Data
   */
  getSeatIds(i) {
    return this.api.getSeatIds(this.puid, i);
  }
  /**
   * @return The list of stands ids
   *
   * @category Data
   */
  getStandIds() {
    return this.api.getBlockIds(this.puid);
  }
  /**
   *
   * @param blockId - id of the block
   * @return The DOM element (polygon) representing the seat
   *
   * @category DOM manipulation
   */
  getBlockElementById(i) {
    var n;
    return ((n = this.iframeEl.contentDocument) == null ? void 0 : n.querySelector(`polygon[data-block="${i}"]`)) ?? null;
  }
  /**
   *
   * @param seatId - id of the seat
   * @return The DOM element (polygon) representing the seat
   *
   * @category DOM manipulation
   */
  getSeatElementById(i) {
    var n;
    return ((n = this.iframeEl.contentDocument) == null ? void 0 : n.querySelector(`polygon[data-seat="${i}"]`)) ?? null;
  }
  /**
   *
   * @param standId - id of the seat
   * @return The DOM element (polygon) representing the seat
   *
   * @category DOM manipulation
   */
  getStandElementById(i) {
    var n;
    return ((n = this.iframeEl.contentDocument) == null ? void 0 : n.querySelector(`polygon[data-stand="${i}"]`)) ?? null;
  }
  cleanContent(i) {
    return i = i.replace(/<html.*?>/, '<html style="width: 100%; height: 100%">'), i = i.replaceAll(/<script.+?script>/g, ""), i = i.replace(/<body.*?>/, '<body style="width: 100%; height: 100%">'), i = i.replace(/onload.+?class/, " class"), i = i.replaceAll(/selectElement(.*?)/g, ""), i = i.replaceAll(".baseseat", ".baseSeat"), i = i.replace(/<div class="fullpage" id="loader">.*?<\/style>/, Te), i;
  }
  async resetIframe(i = "") {
    var o;
    const n = () => new Promise((a, h) => {
      this.iframeEl.addEventListener("load", () => {
        a();
      }, { once: !0 });
    });
    this.containerEl.replaceChildren(), this.iframeEl = document.createElement("iframe"), this.iframeEl.width = "100%", this.iframeEl.height = "100%", this.containerEl.appendChild(this.iframeEl), this.iframeEl.srcdoc = i, await n(), (o = this.iframeEl.contentDocument) != null && o.getElementById("svgDisplayed") && (this.initControls(), this.updateOnResize(), this.setupZoomButtons(this.iframeEl.contentDocument), this.addCustomCSS(this.iframeEl.contentDocument));
  }
  setupZoomButtons(i) {
    if (!this.options.showZoomButtons)
      return;
    const n = i.createElement("button");
    n.id = "zoom-in", i.body.appendChild(n);
    const o = i.createElement("button");
    o.id = "zoom-out", i.body.appendChild(o), n.addEventListener("click", (a) => {
      this.zoom(this.getZoom() + 1);
    }), o.addEventListener("click", (a) => {
      this.zoom(this.getZoom() - 1);
    });
  }
  addCustomCSS(i) {
    const n = i.createElement("style");
    n.innerHTML = `
    #zoom-in,
    #zoom-out{
      width: 40px;
      height: 40px;
      color: white;
      background: transparent;
      position: fixed;
      top: 10px;
      border:none;
      outline: none;
      border-radius:50%;
      cursor:pointer;
      box-sizing:border-box;
      box-shadow: 0 0 5px #00000021;
      border:1px solid white;
      backdrop-filter: blur(5px);
      background:rgba(0,0,0,0.1);
    }
    #zoom-in:before,
    #zoom-in:after,
    #zoom-out:before{ 
      content:"";
      width: 16px;
      height:2px;
      background: white;
      display: block;
      position: absolute; 
      left:50%;
      top:50%;
      transform: translate(-50%, -50%); 
    }
    #zoom-in:after{
      transform: translate(-50%, -50%) rotate(90deg); 
    }
    #zoom-in:hover,
    #zoom-out:hover{
      background:rgba(255,255,255,0.3);
    }
    #zoom-in{
      left:10px;
    }
    #zoom-out{
      left:60px;
      padding-bottom: 10px;
    }
    #requireCtrlOrMetaKeyToZoomWarning{
      transition: opacity 0.1s;
      position: absolute;
      pointer-events: none;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: white;
      color: black;
      font-family: sans-serif;
      user-select: none;
      z-index:1;
    }
    ${this.options.customCSS}
    `, i.body.appendChild(n);
  }
  initControls() {
    this.controls && this.controls.destroy(), this.controls = new di(this.iframeEl, this.options);
  }
  updateOnResize() {
    this.controls && this.controls.updateOnResize();
  }
  /**
   * Enregistrer un callback
   *
   * @category Events
   */
  on(i, n) {
    this.callbacks[i] || (this.callbacks[i] = []), this.callbacks[i].push(n);
  }
  /**
   * Retirer un callback
   *
   * @category Events
   */
  off(i, n) {
    this.callbacks[i] && (this.callbacks[i] = this.callbacks[i].filter((o) => o !== n), this.callbacks[i].length === 0 && delete this.callbacks[i]);
  }
  /**
   * Déclencher un événement
   * @param event
   * @param args
   *
   * @category Events
   */
  emit(i, ...n) {
    const o = this.callbacks[i];
    o && o.forEach((a) => a(...n));
  }
  /**
   * Set current zoom value
   *
   * @param scale
   *
   * @category Controls
   */
  zoom(i) {
    var n;
    (n = this.controls) == null || n.panZoomSVG.zoom(i);
  }
  /**
   * Get current zoom value
   *
   * @category Controls
   */
  getZoom() {
    var i;
    return ((i = this.controls) == null ? void 0 : i.panZoomSVG.getZoom()) || 0;
  }
  /**
   * Move to point
   *
   * @param point
   *
   * @category Controls
   */
  pan(i) {
    var n;
    (n = this.controls) == null || n.panZoomSVG.pan(i);
  }
  /**
   * Get current position
   *
   * @category Controls
   */
  getPan() {
    var i;
    return ((i = this.controls) == null ? void 0 : i.panZoomSVG.getPan()) || null;
  }
}
export {
  we as VIEWER_DEFAULT_OPTIONS,
  gi as Viewer
};
